import { Course } from '../types/course';

// OSTATECZNA WERSJA MOCKOWYCH KURSÓW (2024-07-29 v4)
// - Poprawiono/zaktualizowano imageUrl dla wskazanych kursów.
// - Potwierdzono polskie poziomy trudności, format duration, strukturę plan, realizm danych.
// - Liczba kursów: 46.
export const mockUdemyCourses: Course[] = [
  // --- Finanse osobiste i Inwestowanie ---
  {
    id: 'budget-7dni',
    title: 'Twój Budżet Domowy Pod Kontrolą w 7 Dni!',
    category: 'Finanse osobiste',
    tags: ['budżet', 'finanse osobiste', 'oszczędzanie', 'planowanie budżetu', 'zarządzanie pieniędzmi', 'kontrola wydatków', 'excel', 'google sheets', 'pieniądze'],
    imageUrl: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&q=80&w=400', // Nowy URL - bardziej domowy budżet
    price: 79.99,
    originalPrice: 99.99,
    currency: 'PLN',
    rating: 4.9,
    reviews: 2135,
    level: 'początkujący',
    duration: '7 dni (ok. 1h materiału dziennie)',
    certificate: true,
    bestSeller: true,
    description: 'Masz dość chaosu w finansach? Ten 7-dniowy intensywny kurs online krok po kroku nauczy Cię zarządzać domowym budżetem od zera. Praktyczne zadania, gotowe checklisty i szablony (Excel/Google Sheets) pomogą Ci odzyskać kontrolę i zacząć świadomie oszczędzać.',
    instructor: 'FinanseNaPlus',
    affiliateUrl: '#',
    textOnly: false,
    plan: [
      'Zrozumienie przepływów finansowych i spisanie dochodów/wydatków',
      'Efektywne śledzenie wydatków zmiennych (metody i aplikacje)',
      'Analiza wydatków i tworzenie kategorii budżetowych',
      'Tworzenie realistycznego planu budżetu (metody 50/30/20 i inne)',
      'Redukcja wydatków - skuteczne strategie bez wyrzeczeń',
      'Planowanie celów finansowych i budowanie poduszki bezpieczeństwa',
      'Automatyzacja finansów i budowanie zdrowych nawyków finansowych'
    ],
    forWho: [
      'Dla osób, które nigdy nie prowadziły budżetu domowego',
      'Dla tych, którzy czują, że pieniądze "przeciekają im przez palce"',
      'Dla osób chcących zacząć świadomie oszczędzać na konkretne cele',
      'Dla par i rodzin szukających wspólnego systemu zarządzania finansami',
      'Dla każdego, kto chce zyskać spokój i kontrolę nad swoimi pieniędzmi'
    ],
    whatYouGet: [
      'Praktyczną umiejętność tworzenia i zarządzania budżetem domowym',
      'Gotowe, edytowalne szablony budżetu (Excel, Google Sheets)',
      'Checklisty i zadania do wdrożenia od zaraz',
      'Głębsze zrozumienie własnych nawyków finansowych',
      'Konkretny plan budowania poduszki finansowej',
      'Wiedzę przekazaną prostym językiem, bez skomplikowanego żargonu',
      'Większą pewność siebie w podejmowaniu decyzji finansowych'
    ],
    faq: [
      { q: 'Czy potrzebuję specjalistycznej wiedzy finansowej?', a: 'Absolutnie nie! Kurs jest zaprojektowany dla osób początkujących i prowadzi krok po kroku, od samych podstaw.' },
      { q: 'Czy muszę używać Excela lub Google Sheets?', a: 'Dostarczamy szablony w obu formatach. Możesz też adaptować metody do innych aplikacji budżetowych, o których wspominamy w kursie.' },
      { q: 'Ile czasu dziennie muszę poświęcić?', a: 'Każdy dzień to około 30-60 minut materiału i zadań praktycznych. Najwięcej czasu zajmie pierwsze spisanie wydatków.' }
    ]
  },
  {
    id: 'cv-list-motywacyjny',
    title: 'Skuteczne CV i List Motywacyjny – Zdobądź Pracę Marzeń!',
    category: 'Kariera',
    tags: ['cv', 'curriculum vitae', 'list motywacyjny', 'podanie o pracę', 'rekrutacja', 'szukanie pracy', 'ats', 'linkedin', 'dokumenty aplikacyjne', 'pierwsza praca'],
    imageUrl: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?auto=format&fit=crop&q=80&w=400', // OK
    price: 89.99,
    originalPrice: 119.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 1850,
    level: 'początkujący',
    duration: '6 lekcji (ok. 3-4h materiału)',
    certificate: true,
    bestSeller: true,
    description: 'Twój klucz do sukcesu w rekrutacji! Ten praktyczny kurs online pokaże Ci, jak stworzyć profesjonalne CV i przekonujący list motywacyjny, które wyróżnią Cię na tle konkurencji i pokonają systemy ATS. Poznaj najnowsze trendy, unikaj błędów i zdobądź pracę, o której marzysz dzięki gotowym szablonom i sprawdzonym wskazówkom.',
    instructor: 'Doświadczona Rekruterka HR',
    affiliateUrl: '#',
    textOnly: false,
    plan: [
      'Anatomia skutecznego CV (sekcje, struktura, błędy)',
      'Opis doświadczenia i osiągnięć (metoda STAR)',
      'Sekcja umiejętności i podsumowanie zawodowe',
      'Dopasowanie do oferty i optymalizacja pod ATS',
      'Tworzenie perswazyjnego listu motywacyjnego',
      'Dodatkowe elementy (LinkedIn, portfolio) i wysyłka'
    ],
    forWho: [
      'Dla absolwentów i studentów szukających pierwszej pracy lub stażu',
      'Dla osób planujących zmianę branży lub stanowiska',
      'Dla tych, którzy wysyłają dużo aplikacji, ale nie otrzymują zaproszeń na rozmowy',
      'Dla każdego, kto chce stworzyć profesjonalne i skuteczne dokumenty aplikacyjne',
      'Dla osób wracających na rynek pracy po przerwie'
    ],
    whatYouGet: [
      'Gotowe, nowoczesne szablony CV i listu motywacyjnego do łatwej edycji (np. w Word, Google Docs)',
      'Praktyczne checklisty do samodzielnej weryfikacji dokumentów przed wysłaniem',
      'Konkretne przykłady dobrych i złych praktyk oraz "mocnych" czasowników',
      'Listy kluczowych umiejętności twardych i miękkich poszukiwanych przez pracodawców',
      'Instrukcje krok po kroku i praktyczne wskazówki od doświadczonej rekruterki',
      'Wiedzę o działaniu systemów ATS i sposobach na zwiększenie widoczności aplikacji'
    ],
    faq: [
      { q: 'Czy kurs jest aktualny na obecny rok?', a: 'Tak, materiały i szablony uwzględniają najnowsze trendy rekrutacyjne, w tym działanie systemów ATS i oczekiwania pracodawców.' },
      { q: 'Czy dostanę gotowe wzory do wypełnienia?', a: 'Tak, kurs zawiera linki do edytowalnych szablonów w popularnych formatach, które możesz dostosować do swoich potrzeb.' },
      { q: 'Czy kurs obejmuje przygotowanie do rozmowy kwalifikacyjnej?', a: 'Kurs koncentruje się na tworzeniu dokumentów aplikacyjnych. Przygotowanie do rozmowy to osobny temat, choć dobrze napisane CV jest świetną bazą do rozmowy.' }
    ]
  },
  {
    id: 'inwestowanie-gielda-poczatek',
    title: 'Giełda dla Początkujących: Twoje Pierwsze Kroki w Świecie Inwestycji',
    category: 'Inwestowanie',
    tags: ['inwestowanie', 'giełda', 'akcje', 'etf', 'fundusze indeksowe', 'pasywne inwestowanie', 'broker', 'makler', 'analiza fundamentalna', 'dywersyfikacja', 'ryzyko inwestycyjne', 'oszczędności'],
    imageUrl: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&q=80&w=400', // OK
    price: 249.99,
    originalPrice: 349.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 1100,
    level: 'początkujący',
    duration: 'ok. 4-5 godzin materiału',
    certificate: true,
    bestSeller: true,
    description: 'Chcesz zacząć inwestować, ale giełda wydaje Ci się skomplikowana? Ten kurs odczaruje świat inwestycji! Zrozumiesz podstawy działania giełdy, nauczysz się wybierać brokera, poznasz akcje i fundusze ETF, opanujesz podstawy analizy i zbudujesz swój pierwszy, zdywersyfikowany portfel. Inwestuj mądrze i długoterminowo!',
    instructor: 'Inwestor Praktyk',
    affiliateUrl: '#',
    plan: [
      'Dlaczego warto inwestować? Podstawy giełdy.',
      'Rodzaje instrumentów finansowych (akcje, obligacje, ETF).',
      'Wybór brokera - kluczowe kryteria.',
      'Podstawy analizy fundamentalnej spółek.',
      'Budowanie portfela inwestycyjnego (dywersyfikacja, ryzyko).',
      'Strategie inwestycyjne (pasywne vs aktywne, rola ETF).',
      'Psychologia inwestowania i unikanie błędów.',
      'Podatki od zysków kapitałowych w Polsce.'
    ],
    forWho: [
      'Dla osób, które chcą zacząć inwestować swoje oszczędności, ale nie wiedzą od czego zacząć.',
      'Dla tych, którzy obawiają się ryzyka i chcą zrozumieć mechanizmy giełdowe.',
      'Dla osób szukających alternatywy dla nisko oprocentowanych lokat bankowych.',
      'Dla każdego, kto chce budować swój majątek w perspektywie długoterminowej.'
    ],
    whatYouGet: [
      'Solidne zrozumienie mechanizmów działania giełdy i podstawowych pojęć.',
      'Umiejętność świadomego wyboru odpowiedniego brokera.',
      'Wiedzę o podstawach analizy spółek giełdowych i funduszy ETF.',
      'Praktyczne strategie budowania zdywersyfikowanego portfela inwestycyjnego.',
      'Świadomość psychologicznych pułapek czyhających na inwestorów.',
      'Konkretne wskazówki dotyczące dokonywania pierwszych transakcji.',
      'Wiedzę o podstawowych obowiązkach podatkowych inwestora.'
    ],
    faq: [
      { q: 'Czy muszę mieć duży kapitał na start?', a: 'Nie, kurs pokazuje jak zacząć nawet z niewielkimi kwotami, np. regularnie inwestując w jednostki funduszy ETF.' },
      { q: 'Czy inwestowanie na giełdzie jest bardzo ryzykowne?', a: 'Każda inwestycja wiąże się z ryzykiem, ale kurs uczy, jak je świadomie oceniać i minimalizować poprzez dywersyfikację i długoterminowe podejście.' },
      { q: 'Czy kurs poleca konkretne akcje lub fundusze?', a: 'Nie, kurs uczy jak samodzielnie analizować i podejmować decyzje inwestycyjne, a nie daje gotowych rekomendacji.' }
    ]
  },
  {
    id: 'kredyt-hipoteczny-przewodnik',
    title: 'Kredyt Hipoteczny Bez Tajemnic - Przewodnik Krok po Kroku 2024',
    category: 'Finanse osobiste',
    tags: ['kredyt hipoteczny', 'mieszkanie', 'dom', 'zakup nieruchomości', 'finansowanie', 'zdolność kredytowa', 'wkład własny', 'marża', 'prowizja', 'rrso', 'negocjacje z bankiem'],
    imageUrl: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&q=80&w=400', // OK
    price: 149.99,
    currency: 'PLN',
    rating: 4.7,
    reviews: 780,
    level: 'początkujący',
    duration: 'ok. 2-3 godziny materiału',
    certificate: false,
    bestSeller: false,
    description: 'Planujesz zakup mieszkania lub domu na kredyt? Ten kompleksowy kurs online przeprowadzi Cię przez cały, często skomplikowany, proces kredytowy - od rzetelnego obliczenia zdolności kredytowej, przez zgromadzenie wkładu własnego, wybór najkorzystniejszej oferty, negocjacje z bankiem, aż po analizę umowy i finalizację transakcji. Uniknij kosztownych błędów i świadomie wybierz najlepszy kredyt dla siebie!',
    instructor: 'Ekspert Kredytowy Niezależny',
    affiliateUrl: '#',
    plan: [
      'Zdolność kredytowa - jak ją obliczyć i poprawić?',
      'Wkład własny - wymagania, źródła, programy.',
      'Rodzaje kredytów i oprocentowania (stałe vs zmienne).',
      'Porównywanie ofert banków (RRSO, marża, prowizja, ubezpieczenia).',
      'Proces wnioskowania o kredyt i wymagane dokumenty.',
      'Negocjacje warunków umowy kredytowej.',
      'Analiza kluczowych zapisów umowy kredytowej.',
      'Dodatkowe koszty i zasady wcześniejszej spłaty.'
    ],
    forWho: [
      'Dla osób planujących zakup pierwszej nieruchomości na kredyt.',
      'Dla tych, którzy chcą zrozumieć zawiłości procesu kredytowego przed podjęciem decyzji.',
      'Dla osób szukających sposobów na znalezienie najtańszej i najlepszej oferty kredytowej.',
      'Dla każdego, kto chce świadomie i bezpiecznie przejść przez proces uzyskania kredytu hipotecznego.'
    ],
    whatYouGet: [
      'Pełne zrozumienie procesu ubiegania się o kredyt hipoteczny od A do Z.',
      'Umiejętność samodzielnej oceny własnej zdolności kredytowej.',
      'Wiedzę niezbędną do porównywania i wybierania najlepszych ofert bankowych.',
      'Praktyczne wskazówki dotyczące negocjacji warunków z bankiem.',
      'Świadomość potencjalnych pułapek i ukrytych kosztów.',
      'Checklisty wymaganych dokumentów i kluczowych punktów umowy do analizy.'
    ],
    faq: [
      { q: 'Czy kurs pomoże mi wybrać konkretną ofertę banku?', a: 'Kurs uczy, jak samodzielnie analizować i porównywać oferty dostępne na rynku, aby wybrać najlepszą dla Twojej sytuacji, ale nie promuje żadnego konkretnego banku.' },
      { q: 'Czy informacje w kursie są aktualne?', a: 'Kurs omawia ogólne zasady, mechanizmy i kluczowe parametry procesu kredytowego, które są w dużej mierze stałe. Wskazuje również, gdzie szukać aktualnych stawek, regulacji i ofert rynkowych.' },
      { q: 'Czy ten kurs zastąpi doradcę kredytowego?', a: 'Kurs dostarcza kompleksowej wiedzy, która pozwoli Ci lepiej zrozumieć proces i świadomiej rozmawiać z doradcą lub samodzielnie wybrać ofertę. Nie zastępuje jednak indywidualnej porady doradcy, który zna Twoją specyficzną sytuację finansową.' }
    ]
  },
  {
    id: 'negocjacje-wynagrodzenia',
    title: 'Mistrz Negocjacji: Wywalcz Wyższe Wynagrodzenie i Podwyżkę',
    category: 'Kariera',
    tags: ['negocjacje', 'wynagrodzenie', 'pensja', 'podwyżka', 'negocjacja pensji', 'oferta pracy', 'rozmowa kwalifikacyjna', 'komunikacja', 'asertywność', 'badanie rynku pracy', 'zarobki'],
    imageUrl: 'https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?auto=format&fit=crop&q=80&w=400', // OK
    price: 129.99,
    currency: 'PLN',
    rating: 4.9,
    reviews: 990,
    level: 'średniozaawansowany',
    duration: 'ok. 1.5-2 godziny materiału',
    certificate: true,
    bestSeller: true,
    description: 'Nie zostawiaj pieniędzy na stole! Naucz się skutecznie negocjować swoje wynagrodzenie podczas przyjmowania nowej oferty pracy lub rozmowy o podwyżkę. Poznaj sprawdzone techniki, dowiedz się, jak badać stawki rynkowe i budować mocną argumentację opartą na Twojej wartości. Zwiększ swoje zarobki i pewność siebie!',
    instructor: 'Doświadczony Negocjator Biznesowy',
    affiliateUrl: '#',
    plan: [
      'Psychologia negocjacji płacowych.',
      'Badanie rynku pracy i widełek płacowych.',
      'Przygotowanie do rozmowy negocjacyjnej (BATNA, cel, strategia).',
      'Skuteczne techniki i strategie negocjacyjne.',
      'Radzenie sobie z trudnymi pytaniami i obiekcjami.',
      'Negocjowanie dodatkowych benefitów.',
      'Kiedy i jak prosić o podwyżkę?',
      'Typowe błędy w negocjacjach płacowych.'
    ],
    forWho: [
      'Dla osób aktywnie szukających nowej pracy i stojących przed negocjacją oferty.',
      'Dla pracowników, którzy chcą ubiegać się o podwyżkę, ale nie wiedzą, jak się do tego zabrać.',
      'Dla specjalistów i managerów chcących pewniej rozmawiać o finansach w kontekście zawodowym.',
      'Dla każdego, kto czuje, że zarabia poniżej swojej wartości rynkowej.'
    ],
    whatYouGet: [
      'Dogłębne zrozumienie procesu negocjacji wynagrodzenia z obu stron.',
      'Umiejętność rzetelnego badania widełek płacowych i określania swojej wartości.',
      'Konkretne techniki budowania silnej i przekonującej argumentacji.',
      'Sprawdzone strategie i taktyki negocjacyjne do zastosowania w praktyce.',
      'Sposoby na asertywne radzenie sobie ze stresem, obiekcjami i trudnymi sytuacjami.',
      'Większą pewność siebie i skuteczność w rozmowach o pieniądzach.',
      'Wskazówki dotyczące negocjowania benefitów pozapłacowych.'
    ],
    faq: [
      { q: 'Czy kurs gwarantuje uzyskanie wyższego wynagrodzenia lub podwyżki?', a: 'Kurs dostarcza sprawdzonych narzędzi, technik i wiedzy, które znacząco zwiększają Twoje szanse na wynegocjowanie lepszych warunków. Ostateczny wynik zależy jednak od wielu czynników, w tym sytuacji rynkowej i polityki firmy.' },
      { q: 'Czy przedstawione techniki są uniwersalne dla różnych branż?', a: 'Tak, kurs opiera się na uniwersalnych zasadach psychologii i strategii negocjacji, które można z powodzeniem stosować w różnych branżach i na różnych poziomach stanowisk.' },
      { q: 'Czy kurs jest odpowiedni dla osób bez doświadczenia w negocjacjach?', a: 'Tak, kurs tłumaczy wszystko od podstaw, ale wymaga pewnej świadomości swojej roli zawodowej i rynku pracy, aby móc skutecznie zastosować omawiane techniki.' }
    ]
  },
  {
    id: 'linkedin-marka-osobista',
    title: 'LinkedIn Power: Zbuduj Markę Osobistą, Zdobądź Klientów lub Pracę',
    category: 'Kariera',
    tags: ['linkedin', 'marka osobista', 'personal branding', 'networking', 'social selling', 'szukanie pracy', 'pozyskiwanie klientów', 'content marketing', 'budowanie sieci kontaktów'],
    imageUrl: 'https://images.unsplash.com/photo-1611944212129-2991b4871a13?auto=format&fit=crop&q=80&w=400', // Nowy URL - bardziej LinkedIn
    price: 199.99,
    originalPrice: 249.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 1300,
    level: 'średniozaawansowany',
    duration: 'ok. 3-4 godziny materiału i zadań',
    certificate: true,
    bestSeller: true,
    description: 'Wykorzystaj pełen potencjał LinkedIn do rozwoju kariery lub biznesu! Ten kompleksowy kurs nauczy Cię tworzyć profil, który przyciąga uwagę, strategicznie budować wartościową sieć kontaktów, publikować angażujące treści i aktywnie używać LinkedIn do znalezienia pracy lub pozyskania klientów (social selling).',
    instructor: 'Certyfikowany Ekspert LinkedIn & Personal Brandingu',
    affiliateUrl: '#',
    plan: [
      'Fundamenty LinkedIn i działanie algorytmu.',
      'Optymalizacja profilu od A do Z (zdjęcie, nagłówek, opis, doświadczenie).',
      'Strategie budowania wartościowej sieci kontaktów.',
      'Tworzenie angażujących treści (posty, artykuły, wideo).',
      'Budowanie marki osobistej eksperta.',
      'Aktywne wykorzystanie LinkedIn do szukania pracy.',
      'Social Selling - pozyskiwanie klientów na LinkedIn.',
      'Narzędzia analityczne i mierzenie efektywności.'
    ],
    forWho: [
      'Dla profesjonalistów (z każdej branży) chcących świadomie budować swoją markę osobistą online.',
      'Dla osób aktywnie szukających pracy lub otwartych na nowe możliwości zawodowe.',
      'Dla freelancerów, konsultantów i przedsiębiorców szukających klientów B2B.',
      'Dla sprzedawców, marketerów i specjalistów HR.',
      'Dla każdego, kto chce efektywnie wykorzystać potencjał największej sieci zawodowej świata.'
    ],
    whatYouGet: [
      'Profesjonalnie zoptymalizowany profil na LinkedIn, który przyciąga uwagę.',
      'Konkretne strategie budowania wartościowej sieci kontaktów zawodowych.',
      'Umiejętność tworzenia różnorodnych i angażujących treści (nawet bez "talentu" pisarskiego).',
      'Głębsze zrozumienie działania algorytmu LinkedIn i sposobów na zwiększenie zasięgów.',
      'Praktyczne metody wykorzystania LinkedIn do aktywnego szukania pracy lub pozyskiwania klientów.',
      'Wiedzę o narzędziach analitycznych i sposobach mierzenia postępów.',
      'Większą widoczność i rozpoznawalność w swojej branży.'
    ],
    faq: [
      { q: 'Czy muszę mieć płatne konto Premium na LinkedIn, aby skorzystać z kursu?', a: 'Nie, kurs koncentruje się przede wszystkim na maksymalnym wykorzystaniu darmowych funkcji LinkedIn. Omawiamy również korzyści i zastosowania kont Premium, ale nie są one wymagane do realizacji kursu.' },
      { q: 'Ile czasu muszę poświęcać na LinkedIn po ukończeniu kursu, aby widzieć efekty?', a: 'Kurs uczy efektywnych strategii. Regularna, nawet krótka (15-30 minut dziennie) aktywność oparta na zasadach z kursu przynosi lepsze rezultaty niż sporadyczne, długie sesje.' },
      { q: 'Czy kurs jest odpowiedni dla osób początkujących na LinkedIn?', a: 'Tak, zaczynamy od podstaw optymalizacji profilu, ale szybko przechodzimy do bardziej zaawansowanych strategii działania, więc skorzystają zarówno początkujący, jak i osoby już aktywne na platformie.' }
    ]
  },
  {
    id: 'komunikacja-w-zespole',
    title: 'Efektywna Komunikacja i Rozwiązywanie Konfliktów w Zespole',
    category: 'Umiejętności miękkie',
    tags: ['komunikacja interpersonalna', 'praca zespołowa', 'zarządzanie konfliktem', 'feedback', 'informacja zwrotna', 'asertywność', 'inteligencja emocjonalna', 'umiejętności miękkie', 'współpraca', 'relacje w pracy'],
    imageUrl: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&q=80&w=400', // OK
    price: 179.99,
    currency: 'PLN',
    rating: 4.7,
    reviews: 650,
    level: 'początkujący',
    duration: 'ok. 2-3 godziny materiału i ćwiczeń',
    certificate: true,
    bestSeller: false,
    description: 'Popraw współpracę i atmosferę w zespole dzięki kluczowym umiejętnościom komunikacyjnym. Ten praktyczny kurs nauczy Cię udzielać i przyjmować feedback, komunikować się asertywnie, rozumieć różne style komunikacji i konstruktywnie podchodzić do konfliktów. Buduj lepsze relacje zawodowe!',
    instructor: 'Certyfikowany Trener Komunikacji i Mediator',
    affiliateUrl: '#',
    plan: [
      'Znaczenie komunikacji i bariery komunikacyjne.',
      'Style komunikacji (pasywny, agresywny, asertywny).',
      'Aktywne słuchanie i zadawanie pytań.',
      'Asertywność w praktyce - wyrażanie potrzeb i granic.',
      'Konstruktywny feedback (modele FUKO, SBI).',
      'Dynamika konfliktu w zespole.',
      'Strategie rozwiązywania konfliktów (NVC).',
      'Budowanie zaufania i bezpieczeństwa w zespole.',
      'Komunikacja w zespołach zdalnych/hybrydowych.'
    ],
    forWho: [
      'Dla członków zespołów projektowych i stałych, którzy chcą poprawić współpracę.',
      'Dla liderów zespołów, managerów i kierowników projektów.',
      'Dla osób, które mają trudności z wyrażaniem swojego zdania lub radzeniem sobie z krytyką.',
      'Dla specjalistów HR i osób odpowiedzialnych za rozwój pracowników.',
      'Dla każdego, kto chce budować lepsze, bardziej efektywne i satysfakcjonujące relacje zawodowe.'
    ],
    whatYouGet: [
      'Zrozumienie własnego stylu komunikacji i wpływu na innych.',
      'Umiejętność aktywnego słuchania i zadawania pytań pogłębiających zrozumienie.',
      'Praktyczne techniki asertywnej komunikacji do zastosowania w codziennych sytuacjach.',
      'Konkretny model udzielania i przyjmowania feedbacku, który buduje, a nie rani.',
      'Narzędzia do diagnozowania przyczyn konfliktów i wyboru odpowiedniej strategii ich rozwiązania.',
      'Większą świadomość roli komunikacji w budowaniu efektywnego i zgranego zespołu.',
      'Umiejętność adaptacji komunikacji do specyfiki pracy zdalnej/hybrydowej.'
    ],
    faq: [
      { q: 'Czy kurs jest odpowiedni dla osób bardzo nieśmiałych lub introwertycznych?', a: 'Tak, kurs dostarcza konkretnych narzędzi i technik, które pomagają budować pewność siebie w komunikacji i wyrażać swoje zdanie w sposób komfortowy, również dla osób introwertycznych.' },
      { q: 'Czy te umiejętności przydadzą się tylko w pracy?', a: 'Absolutnie nie! Zasady skutecznej komunikacji, asertywności i rozwiązywania konfliktów są uniwersalne i równie cenne w relacjach prywatnych, rodzinnych i społecznych.' },
      { q: 'Czy kurs zawiera praktyczne ćwiczenia?', a: 'Tak, oprócz materiałów tekstowych, kurs zawiera ćwiczenia indywidualne i scenariusze do przemyślenia, które pomagają przełożyć teorię na praktykę.' }
    ]
  },

  // --- IT: Frontend ---
  {
    id: 'react-podstawy',
    title: 'React.js od Podstaw 2024: Twórz Nowoczesne Aplikacje Webowe',
    category: 'Frontend',
    tags: ['react', 'javascript', 'frontend', 'web development', 'programowanie', 'typescript', 'spa', 'single page application', 'hooks', 'react hooks', 'redux', 'redux toolkit', 'react router'],
    imageUrl: 'https://images.unsplash.com/photo-1633356122102-3fe601e05bd2?auto=format&fit=crop&q=80&w=400', // OK
    price: 159.00,
    originalPrice: 219.00,
    currency: 'PLN',
    rating: 4.8,
    reviews: 1550,
    level: 'początkujący',
    duration: 'ok. 8-10 godzin materiału i projektów',
    certificate: true,
    bestSeller: true,
    description: 'Najbardziej aktualny kurs React.js po polsku! Naucz się tworzyć nowoczesne, interaktywne aplikacje webowe (SPA) od zera. Krok po kroku opanujesz komponenty funkcyjne, JSX, zarządzanie stanem (hooki `useState`, `useEffect`, `useContext`), routing (React Router), globalny stan (Redux Toolkit) i podstawy TypeScript w React.',
    instructor: 'DevMentor Polska',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do React i ekosystemu (JSX, Node.js).',
      'Komponenty funkcyjne, Props i struktura projektu.',
      'Zarządzanie stanem komponentu (hook useState).',
      'Cykl życia komponentu i efekty uboczne (hook useEffect).',
      'Renderowanie warunkowe i praca z listami.',
      'Obsługa formularzy i zdarzeń w React.',
      'Dzielenie się stanem (hook useContext).',
      'Routing po stronie klienta z React Router.',
      'Globalne zarządzanie stanem z Redux Toolkit.',
      'Komunikacja z zewnętrznym API (Fetch API).',
      'Metody stylowania komponentów React.',
      'Integracja React z TypeScript - podstawy.',
      'Budowanie aplikacji produkcyjnej i wdrażanie.',
      'Praktyczne projekty do portfolio.'
    ],
    forWho: [
      'Dla osób znających podstawy HTML, CSS i JavaScript (ES6+).',
      'Dla programistów (backend, mobile) chcących nauczyć się nowoczesnego frameworka frontendowego.',
      'Dla osób aspirujących do roli Frontend Developera.',
      'Dla każdego, kto chce tworzyć dynamiczne i interaktywne interfejsy użytkownika dla aplikacji webowych.'
    ],
    whatYouGet: [
      'Solidne i kompleksowe fundamenty biblioteki React.js.',
      'Umiejętność tworzenia rozbudowanych aplikacji Single Page Application (SPA).',
      'Praktyczna znajomość najważniejszych i najczęściej używanych hooków React.',
      'Zrozumienie i umiejętność implementacji globalnego zarządzania stanem za pomocą Redux Toolkit.',
      'Podstawy wykorzystania TypeScript do zwiększenia bezpieczeństwa i jakości kodu React.',
      'Umiejętność komunikacji z zewnętrznym API.',
      'Wiedzę o różnych podejściach do stylowania komponentów.',
      'Umiejętność budowania i przygotowania aplikacji do wdrożenia.',
      'Kilka praktycznych projektów, które możesz dodać do swojego portfolio.'
    ],
    faq: [
      { q: 'Czy muszę znać zaawansowany JavaScript, aby zacząć ten kurs?', a: 'Wystarczą solidne podstawy JavaScript, szczególnie wersja ES6+ (zmienne `let`/`const`, funkcje strzałkowe, `map`, `filter`, `reduce`, destrukturyzacja, moduły). Nie musisz być ekspertem.' },
      { q: 'Czy kurs obejmuje najnowszą wersję React?', a: 'Tak, kurs jest regularnie aktualizowany i opiera się na najnowszych stabilnych wersjach React oraz kluczowych bibliotekach ekosystemu (React Router, Redux Toolkit).' },
      { q: 'Czy kurs obejmuje backend?', a: 'Nie, kurs skupia się wyłącznie na frontendzie z wykorzystaniem React. Komunikujemy się z przykładowym API, ale nie tworzymy go w ramach tego kursu.' }
    ]
  },
  {
    id: 'javascript-zaawansowany',
    title: 'JavaScript dla Zaawansowanych: Koncepcje, Wzorce i Wydajność',
    category: 'Frontend',
    tags: ['javascript', 'js', 'es6', 'es2020+', 'asynchroniczność', 'promises', 'async await', 'programowanie funkcyjne', 'oop', 'prototypy', 'domknięcia', 'wzorce projektowe', 'wydajność', 'struktury danych', 'event loop'],
    imageUrl: 'https://images.unsplash.com/photo-1627398242454-45a1465c2479?auto=format&fit=crop&q=80&w=400', // OK
    price: 299.99,
    currency: 'PLN',
    rating: 4.9,
    reviews: 880,
    level: 'zaawansowany',
    duration: 'ok. 6-8 godzin materiału',
    certificate: true,
    bestSeller: true,
    description: 'Wejdź na poziom ekspercki w JavaScript! Ten kurs to głębokie zanurzenie w zaawansowane mechanizmy języka: asynchroniczność (Event Loop, Promises, async/await), programowanie funkcyjne, OOP (prototypy vs klasy), wzorce projektowe, struktury danych i optymalizację. Niezbędny dla doświadczonych developerów i kandydatów na stanowiska senior.',
    instructor: 'JavaScript Architect & Tech Lead',
    affiliateUrl: '#',
    plan: [
      'Mechanizmy silnika JS (kontekst wykonania, hoisting, scope).',
      'Dogłębne zrozumienie domknięć (closures).',
      'Zaawansowane techniki pracy z funkcjami (this, call, apply, bind, currying).',
      'Programowanie obiektowe: prototypy vs klasy ES6.',
      'Asynchroniczność w JS (Event Loop, Promises, async/await).',
      'Paradygmaty programowania funkcyjnego w praktyce.',
      'Implementacja popularnych wzorców projektowych w JS.',
      'Efektywne wykorzystanie wbudowanych struktur danych.',
      'Praca z modułami ES6.',
      'Techniki optymalizacji wydajności i zarządzania pamięcią.',
      'Przegląd najnowszych funkcji standardu ECMAScript.'
    ],
    forWho: [
      'Dla programistów JavaScript z co najmniej 1-2 letnim doświadczeniem komercyjnym.',
      'Dla osób chcących dogłębnie zrozumieć jak JavaScript działa "pod maską".',
      'Dla developerów przygotowujących się do trudnych, technicznych rozmów rekrutacyjnych na stanowiska Mid/Senior.',
      'Dla tych, którzy chcą pisać bardziej świadomy, wydajny i łatwiejszy w utrzymaniu kod JavaScript.',
      'Dla architektów oprogramowania i liderów technicznych.'
    ],
    whatYouGet: [
      'Głębokie zrozumienie fundamentalnych mechanizmów języka JavaScript.',
      'Pełne opanowanie różnych modeli asynchroniczności w JS.',
      'Umiejętność świadomego stosowania paradygmatów programowania funkcyjnego i obiektowego.',
      'Praktyczną znajomość najważniejszych wzorców projektowych i ich implementacji w JS.',
      'Wiedzę na temat optymalizacji wydajności aplikacji JavaScript.',
      'Gotowość do rozwiązywania złożonych problemów programistycznych i architektonicznych.',
      'Znaczne zwiększenie swojej wartości na rynku pracy jako deweloper JS.'
    ],
    faq: [
      { q: 'Czy kurs obejmuje naukę konkretnych frameworków (React, Angular, Vue)?', a: 'Nie, kurs skupia się wyłącznie na czystym, "waniliowym" JavaScript i jego zaawansowanych koncepcjach. Wiedza ta jest jednak fundamentalna i bezpośrednio przekłada się na lepsze wykorzystanie każdego frameworka.' },
      { q: 'Czy poziom trudności jest naprawdę wysoki?', a: 'Tak, kurs zakłada solidne opanowanie podstaw JavaScript (pętle, warunki, funkcje, podstawy ES6) i wchodzi w tematy wymagające analitycznego myślenia, często pomijane w standardowych kursach "od zera do bohatera".' },
      { q: 'Czy muszę znać TypeScript?', a: 'Nie, kurs koncentruje się na JavaScript. Znajomość TS nie jest wymagana.' }
    ]
  },
  {
    id: 'typescript-kompletny',
    title: 'TypeScript: Kompletny Przewodnik dla Programistów JavaScript',
    category: 'Frontend',
    tags: ['typescript', 'ts', 'javascript', 'statyczne typowanie', 'typy', 'interfejsy', 'klasy', 'generyki', 'typy zaawansowane', 'dekoratory', 'konfiguracja tsconfig', 'frontend', 'backend', 'node.js', 'react', 'angular', 'vue'],
    imageUrl: 'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?auto=format&fit=crop&q=80&w=400', // OK
    price: 179.99,
    originalPrice: 229.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 1150,
    level: 'średniozaawansowany',
    duration: 'ok. 5-6 godzin materiału',
    certificate: true,
    bestSeller: true,
    description: 'Przenieś swój kod JavaScript na wyższy poziom! Opanuj TypeScript od podstaw do zaawansowanych funkcji i pisz bezpieczniejsze, bardziej skalowalne aplikacje. Kurs dla programistów JS obejmuje typy, interfejsy, klasy, generyki, dekoratory, konfigurację TS i integrację z popularnymi frameworkami (React, Node.js).',
    instructor: 'TypeScript & Fullstack Expert',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do TypeScript i korzyści typowania statycznego.',
      'Podstawowe typy danych i wnioskowanie typów.',
      'Definiowanie struktur za pomocą interfejsów i aliasów typów.',
      'Typowanie funkcji (parametry, wartość zwracana).',
      'Klasy i modyfikatory dostępu w TypeScript.',
      'Wykorzystanie typów generycznych (Generics).',
      'Zaawansowane operacje na typach (Union, Intersection, Utility Types).',
      'Wprowadzenie do dekoratorów.',
      'Konfiguracja projektu TypeScript (tsconfig.json).',
      'Praca z modułami i przestrzeniami nazw.',
      'Integracja TypeScript z React i Node.js (przykłady).',
      'Dobre praktyki i wzorce w kodzie TypeScript.'
    ],
    forWho: [
      'Dla programistów JavaScript (frontend/backend), którzy chcą zacząć używać TypeScript.',
      'Dla osób pracujących (lub planujących pracować) z frameworkami takimi jak Angular, React, Vue.js, NestJS, które mocno wykorzystują TS.',
      'Dla programistów chcących pisać bardziej niezawodny, łatwiejszy do refaktoryzacji i skalowania kod.',
      'Dla zespołów programistycznych wdrażających TypeScript w swoich projektach.',
      'Dla każdego, kto chce podnieść swoje umiejętności programistyczne i zwiększyć swoją wartość na rynku pracy.'
    ],
    whatYouGet: [
      'Solidne i kompleksowe zrozumienie systemu typów TypeScript.',
      'Umiejętność definiowania własnych typów za pomocą interfejsów i aliasów.',
      'Biegłość w stosowaniu typów generycznych (Generics) do tworzenia elastycznego kodu.',
      'Praktyczną wiedzę o zaawansowanych możliwościach typowania w TS.',
      'Zrozumienie i umiejętność stosowania dekoratorów.',
      'Umiejętność poprawnej konfiguracji projektu TypeScript (`tsconfig.json`).',
      'Zdolność efektywnej integracji TypeScript z popularnymi narzędziami i frameworkami JS.',
      'Umiejętność pisania czystszego, bezpieczniejszego i bardziej przewidywalnego kodu.'
    ],
    faq: [
      { q: 'Czy muszę perfekcyjnie znać JavaScript, aby rozpocząć ten kurs?', a: 'Musisz znać solidne podstawy JavaScript (ES6+), w tym pracę z funkcjami, obiektami, tablicami i modułami. Im lepiej znasz JS, tym łatwiej będzie Ci zrozumieć koncepcje TS.' },
      { q: 'Czy TypeScript jest trudny do nauczenia dla programisty JS?', a: 'TypeScript jest nadzbiorem JavaScript, co oznacza, że każdy poprawny kod JS jest też (prawie zawsze) poprawnym kodem TS. Nauka polega głównie na dodaniu warstwy typów. Dla programisty JS próg wejścia jest stosunkowo niski, a kurs prowadzi od podstaw.' },
      { q: 'Czy kurs obejmuje wszystkie frameworki (React, Angular, Vue)?', a: 'Kurs skupia się na nauce samego TypeScript. Pokazujemy praktyczne przykłady integracji (np. z React i Node.js), ale nie jest to dogłębny kurs żadnego z tych frameworków w połączeniu z TS.' }
    ]
  },
  {
    id: 'ui-ux-design-figma',
    title: 'UI/UX Design w Figmie od Zera: Projektuj Interfejsy, Które Kochają Użytkownicy',
    category: 'Design',
    tags: ['ui design', 'ux design', 'projektowanie interfejsów', 'user experience', 'user interface', 'figma', 'prototypowanie', 'wireframing', 'design thinking', 'badania użytkowników', 'web design', 'mobile design', 'design system'],
    imageUrl: 'https://images.unsplash.com/photo-1600132806370-bf17e65e942f?auto=format&fit=crop&q=80&w=400', // OK
    price: 239.99,
    currency: 'PLN',
    rating: 4.7,
    reviews: 1610,
    level: 'początkujący',
    duration: 'ok. 6-7 godzin materiału i projekt',
    certificate: true,
    bestSeller: true,
    description: `Zacznij karierę w UI/UX! Ten kompleksowy kurs nauczy Cię projektować interfejsy (UI) i doświadczenia użytkownika (UX) od podstaw, używając Figmy - najpopularniejszego narzędzia w branży. Opanujesz teorię designu, badania UX, tworzenie ` + '`wireframe\'ów`' + `, prototypów i pięknych, użytecznych interfejsów web/mobile. Zbuduj swoje portfolio!`,
    instructor: 'Pixel Perfect Academy & UX Researcher',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do UI/UX Design i procesu Design Thinking.',
      'Fundamenty projektowania graficznego (typografia, kolor, kompozycja).',
      'Podstawy badań UX, tworzenie person i map empatii.',
      'Architektura informacji i projektowanie przepływów użytkownika.',
      'Szkicowanie, Wireframing i prototypowanie (Lo-Fi / Hi-Fi).',
      'Podstawy pracy z Figmą (interfejs, narzędzia, warstwy).',
      'Zaawansowane funkcje Figmy (komponenty, Auto Layout, style).',
      'Tworzenie interaktywnych prototypów w Figmie.',
      'Podstawy testowania użyteczności (Usability Testing).',
      'Wprowadzenie do Design Systems.',
      'Współpraca z deweloperami (Handoff).',
      'Praktyczny projekt UI/UX do portfolio.'
    ],
    forWho: [
      'Dla osób aspirujących do roli UI/UX Designera, które zaczynają od zera.',
      'Dla grafików komputerowych i web designerów chcących poszerzyć swoje kompetencje o UX.',
      'Dla programistów (frontend/fullstack) chcących lepiej rozumieć proces projektowy i współpracę z designerami.',
      'Dla Product Managerów, Project Managerów i właścicieli produktów cyfrowych.',
      'Dla każdego, kto interesuje się tworzeniem intuicyjnych i estetycznych aplikacji oraz stron internetowych.'
    ],
    whatYouGet: [
      'Solidne zrozumienie kluczowych zasad i procesu projektowania UI/UX.',
      'Praktyczną biegłość w obsłudze programu Figma - od podstaw po zaawansowane funkcje.',
      'Umiejętność tworzenia różnych typów makiet (`wireframes`) i interaktywnych prototypów.',
      'Wiedzę na temat projektowania estetycznych, spójnych i funkcjonalnych interfejsów użytkownika.',
      'Podstawową wiedzę o prowadzeniu badań użytkowników i testowaniu użyteczności.',
      'Zrozumienie koncepcji i korzyści płynących z Design Systems.',
      'Umiejętność efektywnej współpracy z zespołem deweloperskim.',
      'Praktyczny projekt UI/UX, który stanie się podstawą Twojego portfolio.'
    ],
    faq: [
      { q: 'Czy potrzebuję płatnej wersji programu Figma?', a: 'Nie, cały kurs można zrealizować, korzystając w 100% z darmowego planu Figmy, który oferuje wszystkie niezbędne funkcjonalności.' },
      { q: 'Czy muszę umieć rysować lub mieć wybitne zdolności artystyczne?', a: 'Niekoniecznie. UI/UX design to w dużej mierze proces rozwiązywania problemów, logicznego myślenia i empatii wobec użytkownika, a nie tylko "ładne obrazki". Zdolności plastyczne mogą pomóc w UI, ale nie są warunkiem koniecznym.' },
      { q: 'Czy kurs obejmuje kodowanie (HTML/CSS)?', a: 'Nie, kurs skupia się wyłącznie na procesie projektowania UI/UX i obsłudze Figmy. Nie uczymy kodowania.' }
    ]
  },

  // --- IT: Backend ---
  {
    id: 'python-django-fullstack',
    title: 'Python i Django: Zostań Full Stack Web Developerem',
    category: 'Backend',
    tags: ['python', 'django', 'backend', 'fullstack', 'web development', 'programowanie', 'html', 'css', 'javascript', 'rest api', 'django rest framework', 'drf', 'orm', 'bazy danych', 'postgresql'],
    imageUrl: 'https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?auto=format&fit=crop&q=80&w=400', // OK
    price: 299.00,
    originalPrice: 399.00,
    currency: 'PLN',
    rating: 4.8,
    reviews: 950,
    level: 'średniozaawansowany',
    duration: 'ok. 10-12 godzin materiału i projekt',
    certificate: true,
    bestSeller: true,
    description: 'Zbuduj kompletne aplikacje webowe od zera! Ten kompleksowy kurs Django nauczy Cię tworzyć backend (modele, ORM, widoki, REST API z DRF) i integrować go z frontendem (szablony Django, podstawy JS). Idealny dla programistów Python chcących wejść w świat web developmentu.',
    instructor: 'Python Web Masters',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do Django i architektury MVT.',
      'Modele Django i ORM (praca z bazą danych).',
      'Widoki i URL routing.',
      'System szablonów Django (Templates).',
      'Formularze Django (tworzenie i walidacja).',
      'Panel administracyjny Django.',
      'Uwierzytelnianie i autoryzacja użytkowników.',
      'Wprowadzenie do Django REST Framework (DRF).',
      'Budowanie REST API za pomocą DRF.',
      'Podstawy integracji frontendu (HTML/CSS/JS) z Django.',
      'Testowanie aplikacji Django.',
      'Podstawy wdrażania aplikacji Django na serwer.'
    ],
    forWho: [
      'Dla programistów Python, którzy chcą nauczyć się tworzyć aplikacje webowe.',
      'Dla osób znających podstawy web developmentu (HTML, CSS, podstawy JS) i chcących poznać potężny framework backendowy.',
      'Dla osób aspirujących do roli Full Stack Developera w ekosystemie Pythona.',
      'Dla tych, którzy chcą nauczyć się tworzyć własne REST API.',
      'Dla studentów i samouków szukających kompleksowego kursu Django.'
    ],
    whatYouGet: [
      'Umiejętność tworzenia pełnoprawnych, dynamicznych aplikacji webowych przy użyciu Django.',
      'Biegłość w pracy z modelami Django, ORM i relacyjnymi bazami danych (np. PostgreSQL).',
      'Zdolność tworzenia funkcjonalnych REST API za pomocą Django REST Framework.',
      'Praktyczną wiedzę na temat implementacji uwierzytelniania i autoryzacji użytkowników.',
      'Zrozumienie jak integrować warstwę frontendową (HTML, CSS, JS) z backendem Django.',
      'Podstawy pisania testów automatycznych dla aplikacji Django.',
      'Wiedzę o procesie wdrażania aplikacji Django na serwer produkcyjny.',
      'Solidny projekt fullstackowy do swojego portfolio.'
    ],
    faq: [
      { q: 'Czy muszę znać Pythona przed rozpoczęciem tego kursu?', a: 'Tak, kurs zakłada solidną znajomość podstaw języka Python (zmienne, typy danych, pętle, warunki, funkcje, podstawy OOP).' },
      { q: 'Czy kurs obejmuje szczegółową naukę frontendu (np. React, Vue)?', a: 'Nie, kurs koncentruje się na Django (backend) i jego systemie szablonów. Pokazujemy podstawy integracji z HTML, CSS i JS, ale nie jest to dogłębny kurs nowoczesnych frameworków frontendowych.' },
      { q: 'Jakiej bazy danych używamy w kursie?', a: 'Django wspiera wiele baz danych. W kursie najczęściej wykorzystujemy PostgreSQL jako przykład produkcyjnej bazy danych, ale wiele koncepcji jest uniwersalnych.' }
    ]
  },
  {
    id: 'node-js-backend-kompletny',
    title: 'Node.js, Express & MongoDB: Zostań Backend Developerem',
    category: 'Backend',
    tags: ['nodejs', 'node.js', 'javascript', 'backend', 'web development', 'express', 'express.js', 'mongodb', 'mongoose', 'api', 'rest api', 'restful', 'graphql', 'api gateway', 'typescript', 'jwt', 'websockets', 'socket.io'],
    imageUrl: 'https://images.unsplash.com/photo-1522199755839-a2bacb67c546?auto=format&fit=crop&q=80&w=400', // OK
    price: 259.00,
    originalPrice: 329.00,
    currency: 'PLN',
    rating: 4.8,
    reviews: 1312,
    level: 'średniozaawansowany',
    duration: 'ok. 12-15 godzin materiału i projektów',
    certificate: true,
    bestSeller: true,
    description: 'Stwórz potężny backend dla swoich aplikacji! Ten kompleksowy kurs Node.js nauczy Cię budować wydajne serwery z Express.js i MongoDB (Mongoose). Opanujesz tworzenie REST API i GraphQL, uwierzytelnianie JWT, WebSockets, testowanie i TypeScript. Idealny dla programistów JS wchodzących w backend.',
    instructor: 'Backend Hero & Node.js Expert',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do Node.js i asynchroniczności.',
      'Podstawy frameworka Express.js (routing, middleware).',
      'Praca z MongoDB i Mongoose ODM.',
      'Budowanie RESTful API (projektowanie, metody HTTP).',
      'Zaawansowane funkcje Express (błędy, walidacja).',
      'Uwierzytelnianie i autoryzacja z JWT.',
      'Wprowadzenie do GraphQL z Apollo Server.',
      'Komunikacja w czasie rzeczywistym z WebSockets (Socket.IO).',
      'Testowanie aplikacji backendowych (jednostkowe, integracyjne).',
      'Wykorzystanie TypeScript w projektach Node.js.',
      'Obsługa przesyłania plików.',
      'Podstawy wdrażania aplikacji Node.js (Docker, chmura).',
      'Dobre praktyki i wzorce architektoniczne.'
    ],
    forWho: [
      'Dla programistów JavaScript (szczególnie frontendowych), którzy chcą specjalizować się w backendzie.',
      'Dla osób chcących nauczyć się tworzyć własne, wydajne API i aplikacje serwerowe od podstaw.',
      'Dla developerów chcących poznać popularny i wszechstronny stos technologiczny (Node.js, Express, MongoDB).',
      'Dla każdego, kto chce tworzyć nowoczesne aplikacje webowe, wymagające komunikacji w czasie rzeczywistym lub elastycznych API (REST/GraphQL).'
    ],
    whatYouGet: [
      'Umiejętność tworzenia zaawansowanych aplikacji backendowych przy użyciu Node.js i Express.js.',
      'Biegłość w pracy z bazą danych MongoDB za pomocą Mongoose.',
      'Praktyczną wiedzę na temat projektowania, implementacji i zabezpieczania RESTful API oraz podstaw GraphQL API.',
      'Umiejętność implementacji bezpiecznego systemu uwierzytelniania opartego na JWT.',
      'Doświadczenie w pracy z WebSockets (Socket.IO) do komunikacji w czasie rzeczywistym.',
      'Podstawy pisania testów automatycznych dla aplikacji backendowych.',
      'Praktyczne doświadczenie w wykorzystaniu TypeScript w środowisku Node.js.',
      'Wiedzę o procesie przygotowania i wdrażania aplikacji Node.js na serwery produkcyjne.',
      'Kilka projektów backendowych do portfolio.'
    ],
    faq: [
      { q: 'Czy muszę znać JavaScript przed rozpoczęciem kursu?', a: 'Tak, bardzo dobra znajomość JavaScript (ES6+), w tym koncepcji asynchroniczności (Promises, async/await), jest absolutnie wymagana.' },
      { q: 'Czy kurs jest odpowiedni dla zupełnie początkujących programistów?', a: 'Kurs jest przeznaczony dla osób, które mają już pewne doświadczenie w programowaniu, zwłaszcza w JavaScript. Nie jest to kurs "od zera".' },
      { q: 'Czy potrzebuję instalować dodatkowe oprogramowanie?', a: 'Tak, potrzebna będzie instalacja Node.js, edytora kodu (np. VS Code) oraz bazy danych MongoDB (lokalnie lub skorzystanie z wersji chmurowej jak MongoDB Atlas).' }
    ]
  },
  {
    id: 'sql-zaawansowany-optymalizacja',
    title: 'SQL i Optymalizacja Zapytań dla Zaawansowanych (PostgreSQL/MySQL)',
    category: 'Bazy danych',
    tags: ['sql', 'bazy danych', 'optymalizacja zapytań', 'indeksy', 'plany wykonania', 'explain', 'transakcje', 'window functions', 'cte', 'postgresql', 'mysql', 'backend', 'analiza danych', 'wydajność baz danych'],
    imageUrl: 'https://images.unsplash.com/photo-1593720219276-0b1eacd0aef4?auto=format&fit=crop&q=80&w=400', // OK
    price: 349.99,
    currency: 'PLN',
    rating: 4.9,
    reviews: 720,
    level: 'zaawansowany',
    duration: 'ok. 6-7 godzin materiału i ćwiczeń',
    certificate: true,
    bestSeller: false,
    description: 'Przyspiesz swoje aplikacje i analizy! Ten kurs dla znających podstawy SQL nauczy Cię pisać złożone, efektywne zapytania i optymalizować ich wydajność. Opanujesz Window Functions, CTEs, zrozumiesz indeksy, nauczysz się analizować plany wykonania (`EXPLAIN`) i zarządzać transakcjami w PostgreSQL/MySQL.',
    instructor: 'Doświadczony DBA & Performance Engineer',
    affiliateUrl: '#',
    plan: [
      'Przypomnienie i utrwalenie podstaw SQL.',
      'Zaawansowane funkcje SQL (Window Functions).',
      'Common Table Expressions (CTEs).',
      'Pisanie złożonych zapytań analitycznych.',
      'Indeksy w bazach danych (rodzaje, zastosowanie).',
      'Analiza planów wykonania zapytań (EXPLAIN).',
      'Techniki optymalizacji zapytań SQL.',
      'Transakcje, poziomy izolacji, blokady.',
      'Podstawy strojenia wydajności bazy danych.',
      'Zaawansowane funkcje PostgreSQL/MySQL (JSON, FTS).',
      'Dobre praktyki i typowe błędy w zaawansowanym SQL.'
    ],
    forWho: [
      'Dla backend developerów, którzy na co dzień pracują z relacyjnymi bazami danych i chcą pisać wydajniejszy kod.',
      'Dla analityków danych i specjalistów Data Science, którzy muszą przetwarzać duże zbiory danych za pomocą SQL.',
      'Dla administratorów baz danych (DBA) i inżynierów danych.',
      'Dla programistów, którzy napotykają problemy z wydajnością aplikacji spowodowane wolnymi zapytaniami do bazy.',
      'Dla każdego, kto zna podstawy SQL i chce wejść na znacznie wyższy poziom umiejętności.'
    ],
    whatYouGet: [
      'Umiejętność pisania złożonych, wieloetapowych i wydajnych zapytań SQL.',
      'Głębokie zrozumienie mechanizmów działania indeksów i umiejętność ich strategicznego stosowania.',
      'Praktyczną wiedzę na temat analizy planów wykonania zapytań i identyfikowania wąskich gardeł.',
      'Konkretne techniki optymalizacji zapytań SQL dla popularnych silników baz danych.',
      'Solidne zrozumienie mechanizmu transakcji, blokad i poziomów izolacji.',
      'Umiejętność wykorzystania zaawansowanych funkcji SQL, takich jak Window Functions i CTEs.',
      'Wiedzę o podstawach administracji i strojenia wydajności baz danych.',
      'Znajomość dobrych praktyk i unikanie typowych błędów przy pracy z SQL.'
    ],
    faq: [
      { q: 'Czy kurs wymaga znajomości konkretnej bazy danych (PostgreSQL czy MySQL)?', a: 'Kurs omawia koncepcje w dużej mierze uniwersalne dla standardu SQL. Przykłady i specyficzne funkcje optymalizacyjne pokazujemy głównie na PostgreSQL i MySQL, wskazując na ewentualne różnice. Znajomość podstaw SQL jest kluczowa.' },
      { q: 'Czy potrzebuję zainstalowanej bazy danych do ćwiczeń?', a: 'Tak, zdecydowanie zalecamy zainstalowanie lokalnie PostgreSQL lub MySQL (lub obu) albo skorzystanie z darmowych instancji baz danych w chmurze (np. AWS RDS Free Tier, ElephantSQL) do praktycznego wykonywania ćwiczeń.' },
      { q: 'Czy poziom jest naprawdę zaawansowany?', a: 'Tak, kurs zakłada, że uczestnik swobodnie posługuje się podstawowymi zapytaniami SQL (SELECT, JOIN, WHERE, GROUP BY). Wchodzimy w tematy wymagające analitycznego myślenia i zrozumienia wewnętrznych mechanizmów bazy danych.' }
    ]
  },

  // --- IT: DevOps & Cloud ---
  {
    id: 'aws-solutions-architect-associate',
    title: 'Projektowanie Rozwiązań w Chmurze AWS (Przygotowanie do SAA-C03)',
    category: 'Cloud',
    tags: ['aws', 'amazon web services', 'cloud computing', 'chmura obliczeniowa', 'certyfikacja aws', 'solutions architect', 'saa-c03', 'architektura chmurowa', 'devops', 'infrastruktura', 'bezpieczeństwo w chmurze', 'wysoka dostępność', 'skalowalność'],
    imageUrl: 'https://images.unsplash.com/photo-1573497491208-6b1acb260507?auto=format&fit=crop&q=80&w=400', // OK
    price: 399.00,
    originalPrice: 499.00,
    currency: 'PLN',
    rating: 4.9,
    reviews: 1890,
    level: 'średniozaawansowany',
    duration: 'ok. 10-12 godzin materiału i testów',
    certificate: true,
    bestSeller: true,
    description: 'Zdobyj umiejętności architekta chmury AWS! Ten kompleksowy kurs przygotuje Cię do certyfikacji SAA-C03, omawiając kluczowe usługi (EC2, S3, VPC, RDS, Lambda) i najlepsze praktyki projektowania bezpiecznych, wydajnych i skalowalnych rozwiązań. Zawiera scenariusze egzaminacyjne i testy.',
    instructor: 'Certyfikowany AWS Cloud Guru PL',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do AWS i architektury chmurowej.',
      'Zarządzanie dostępem i tożsamością (IAM).',
      'Obliczenia w chmurze (EC2).',
      'Przechowywanie danych (S3).',
      'Sieci wirtualne (VPC).',
      'Bazy danych w AWS (RDS, DynamoDB).',
      'Rozwiązania bezserwerowe (Lambda, API Gateway).',
      'Projektowanie architektur aplikacji (Load Balancing, Auto Scaling).',
      'Bezpieczeństwo w chmurze AWS.',
      'Monitorowanie i logowanie (CloudWatch, CloudTrail).',
      'Wysoka dostępność i odzyskiwanie po awarii (HA/DR).',
      'Optymalizacja kosztów w AWS.',
      'Przygotowanie do egzaminu SAA-C03 (testy praktyczne).'
    ],
    forWho: [
      'Dla osób chcących zdać egzamin certyfikacyjny AWS Certified Solutions Architect - Associate (SAA-C03).',
      'Dla inżynierów IT, programistów, administratorów systemów, którzy chcą pracować z chmurą AWS.',
      'Dla obecnych lub przyszłych architektów rozwiązań chmurowych.',
      'Dla specjalistów DevOps wykorzystujących AWS.',
      'Dla każdego, kto chce zdobyć kompleksową i ustrukturyzowaną wiedzę o kluczowych usługach AWS.'
    ],
    whatYouGet: [
      'Kompleksową wiedzę teoretyczną i praktyczną dotyczącą szerokiego zakresu usług AWS.',
      'Dogłębne zrozumienie zasad projektowania bezpiecznych, wydajnych, niezawodnych, skalowalnych i opłacalnych architektur w chmurze AWS.',
      'Praktyczne umiejętności konfiguracji i zarządzania kluczowymi usługami AWS poprzez konsolę i CLI (podstawy).',
      'Doskonałe przygotowanie do formatu i zakresu pytań na egzaminie SAA-C03.',
      'Dostęp do licznych testów praktycznych i quizów sprawdzających wiedzę.',
      'Certyfikat ukończenia kursu (nie jest to oficjalny certyfikat AWS).'
    ],
    faq: [
      { q: 'Czy potrzebuję wcześniejszego doświadczenia z AWS, aby rozpocząć kurs?', a: 'Zalecane jest posiadanie ogólnej wiedzy na temat IT (sieci, systemy operacyjne, bazy danych) i podstawowych koncepcji chmury obliczeniowej. Kurs omawia jednak usługi AWS od podstaw niezbędnych do egzaminu.' },
      { q: 'Czy ukończenie kursu gwarantuje zdanie egzaminu AWS?', a: 'Kurs dostarcza kompleksowej wiedzy i narzędzi potrzebnych do zdania egzaminu. Sukces zależy jednak od Twojego indywidualnego zaangażowania, ilości poświęconego czasu na naukę i praktykę (w tym rozwiązywanie testów).' },
      { q: 'Czy potrzebuję konta AWS do nauki?', a: 'Posiadanie darmowego konta AWS (Free Tier) jest bardzo zalecane, aby móc praktycznie przećwiczyć omawiane usługi. Kurs pokazuje, jak korzystać z Free Tier, aby zminimalizować ewentualne koszty.' }
    ]
  },
  {
    id: 'docker-kubernetes-kompletny',
    title: 'Docker i Kubernetes: Kompletny Kurs Konteneryzacji i Orkiestracji',
    category: 'DevOps',
    tags: ['docker', 'kubernetes', 'k8s', 'konteneryzacja', 'orkiestracja kontenerów', 'devops', 'mikrousługi', 'ci/cd', 'infrastruktura jako kod', 'docker compose', 'helm', 'monitoring', 'prometheus', 'grafana'],
    imageUrl: 'https://images.unsplash.com/photo-1605745341112-85968b19335b?auto=format&fit=crop&q=80&w=400', // OK
    price: 329.99,
    originalPrice: 419.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 1050,
    level: 'średniozaawansowany',
    duration: 'ok. 9-11 godzin materiału i labów',
    certificate: true,
    bestSeller: true,
    description: 'Opanuj kluczowe technologie DevOps! Ten kurs nauczy Cię konteneryzacji z Dockerem (Dockerfile, Compose) i orkiestracji z Kubernetes (Deployments, Services, Ingress, Helm). Zrozumiesz architekturę K8s, zarządzanie konfiguracją, pamięcią, siecią oraz podstawy monitoringu. Niezbędny dla developerów i inżynierów DevOps.',
    instructor: 'DevOps Masters Academy & Kubernetes Certified Admin',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do konteneryzacji i Dockera.',
      'Podstawy pracy z Dockerem (obrazy, kontenery, CLI).',
      'Tworzenie efektywnych obrazów Docker (Dockerfile).',
      'Zarządzanie danymi i siecią w Dockerze (Volumes, Networking).',
      'Definiowanie aplikacji wielokontenerowych z Docker Compose.',
      'Wprowadzenie do Kubernetes i jego architektury.',
      'Podstawowe obiekty Kubernetes (Pods, Deployments, Services).',
      'Zarządzanie konfiguracją (ConfigMaps, Secrets).',
      'Zarządzanie pamięcią masową (Volumes, PV, PVC).',
      'Networking w Kubernetes (Ingress, Network Policies).',
      'Zarządzanie pakietami z Helm.',
      'Monitoring i logowanie w K8s (Prometheus, Grafana).',
      'Podstawy integracji CI/CD z Docker i Kubernetes.',
      'Dobre praktyki i wzorce pracy.'
    ],
    forWho: [
      'Dla programistów (backend/frontend/fullstack), którzy chcą konteneryzować swoje aplikacje i wdrażać je na Kubernetes.',
      'Dla inżynierów DevOps, administratorów systemów i specjalistów od infrastruktury.',
      'Dla osób pracujących z architekturą mikrousług.',
      'Dla każdego, kto chce zrozumieć i stosować nowoczesne praktyki budowania, wdrażania i zarządzania aplikacjami.',
      'Dla osób przygotowujących się do certyfikatów Docker (DCA) lub Kubernetes (CKA/CKAD - jako solidne podstawy).'
    ],
    whatYouGet: [
      'Biegłość w tworzeniu zoptymalizowanych obrazów Docker i zarządzaniu kontenerami.',
      'Umiejętność efektywnego wykorzystania Docker Compose do lokalnego developmentu i testowania.',
      'Dogłębne zrozumienie architektury, komponentów i kluczowych obiektów Kubernetes.',
      'Praktyczne umiejętności wdrażania, skalowania i zarządzania aplikacjami w klastrze Kubernetes.',
      'Wiedzę na temat zarządzania konfiguracją, stanem, pamięcią masową i ruchem sieciowym w K8s.',
      'Umiejętność korzystania z Helma do uproszczenia zarządzania aplikacjami w K8s.',
      'Podstawy konfiguracji monitoringu i logowania dla aplikacji w Kubernetes.',
      'Solidne fundamenty do dalszego rozwoju w obszarze DevOps i technologii chmurowych.',
      'Praktyczne laboratoria i ćwiczenia utrwalające wiedzę.'
    ],
    faq: [
      { q: 'Czy muszę znać system Linux, aby skorzystać z kursu?', a: 'Podstawowa znajomość pracy w linii komend systemu Linux będzie bardzo pomocna, ponieważ większość narzędzi (Docker CLI, kubectl) działa w terminalu.' },
      { q: 'Czy potrzebuję własnego, drogiego klastra Kubernetes do nauki?', a: 'Nie. Kurs pokazuje, jak skonfigurować i korzystać z darmowych, lokalnych narzędzi do uruchamiania Kubernetes (np. Minikube, Kind, Docker Desktop Kubernetes) oraz jak ewentualnie wykorzystać darmowe triale zarządzanych klastrów w chmurze publicznej (np. GKE, EKS, AKS).' },
      { q: 'Czy kurs obejmuje zagadnienia bezpieczeństwa Dogłębnie?', a: 'Kurs porusza podstawowe aspekty bezpieczeństwa związane z obrazami Docker, konfiguracją (Secrets) i siecią (Network Policies) w Kubernetes, ale nie jest to dedykowany kurs bezpieczeństwa tych technologii.' }
    ]
  },
  {
    id: 'terraform-iac',
    title: 'Automatyzacja Chmury z Terraform: Infrastruktura jako Kod (AWS, Azure, GCP)',
    category: 'DevOps',
    tags: ['terraform', 'iac', 'infrastructure as code', 'infrastruktura jako kod', 'hashicorp', 'hcl', 'aws', 'azure', 'gcp', 'google cloud', 'devops', 'automatyzacja infrastruktury', 'cloud automation', 'zarządzanie stanem'],
    imageUrl: 'https://images.unsplash.com/photo-1665686308827-eb62e4f6604d?auto=format&fit=crop&q=80&w=400', // Nowy URL - chmura/kod
    price: 279.99,
    currency: 'PLN',
    rating: 4.7,
    reviews: 680,
    level: 'początkujący',
    duration: 'ok. 4-5 godzin materiału i przykładów',
    certificate: true,
    bestSeller: false,
    description: 'Zarządzaj infrastrukturą chmurową (AWS, Azure, GCP) jak profesjonalista! Ten kurs nauczy Cię Terraform - kluczowego narzędzia Infrastructure as Code (IaC). Opanujesz język HCL, zarządzanie stanem, pracę z providerami, zmienne, outputy i moduły. Zautomatyzuj tworzenie i zarządzanie infrastrukturą!',
    instructor: 'Cloud Automation Pro & Terraform Certified Associate',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do Infrastruktury jako Kod (IaC) i Terraform.',
      'Podstawy języka HCL (zasoby, dostawcy).',
      'Podstawowy przepływ pracy Terraform (init, plan, apply, destroy).',
      'Parametryzacja kodu (zmienne, outputy).',
      'Zarządzanie stanem Terraform (lokalny vs zdalny).',
      'Praca z dostawcami chmury (przykłady AWS, Azure, GCP).',
      'Wyrażenia, funkcje wbudowane i zależności.',
      'Pętle i warunki w Terraform.',
      'Moduły Terraform - tworzenie i wykorzystanie.',
      'Dobre praktyki i organizacja kodu Terraform.',
      'Podstawy integracji Terraform z CI/CD.'
    ],
    forWho: [
      'Dla inżynierów DevOps, administratorów systemów i specjalistów od chmury.',
      'Dla programistów, którzy chcą samodzielnie zarządzać infrastrukturą dla swoich aplikacji.',
      'Dla osób chcących zautomatyzować powtarzalne zadania związane z tworzeniem i modyfikacją infrastruktury.',
      'Dla architektów rozwiązań chcących definiować architekturę za pomocą kodu.',
      'Dla każdego, kto chce poznać i zacząć efektywnie używać kluczowego narzędzia IaC, jakim jest Terraform.'
    ],
    whatYouGet: [
      'Solidne zrozumienie koncepcji i korzyści płynących z podejścia Infrastructure as Code.',
      'Praktyczną biegłość w posługiwaniu się narzędziem Terraform i jego kluczowymi komendami.',
      'Umiejętność pisania czytelnego i parametryzowalnego kodu w języku HCL.',
      'Wiedzę na temat tworzenia i zarządzania podstawowymi zasobami u głównych dostawców chmury (AWS, Azure, GCP) za pomocą Terraform.',
      'Zrozumienie znaczenia i sposobów zarządzania stanem Terraform.',
      'Umiejętność tworzenia i wykorzystywania reużywalnych modułów Terraform.',
      'Znajomość dobrych praktyk organizacji kodu IaC i podstaw integracji z CI/CD.',
      'Fundamenty do dalszej nauki i potencjalnej certyfikacji Terraform Associate.'
    ],
    faq: [
      { q: 'Czy muszę znać konkretną platformę chmurową (AWS, Azure, GCP) przed kursem?', a: 'Podstawowa znajomość przynajmniej jednej platformy chmurowej (czym jest VM, sieć, storage) jest bardzo pomocna, aby zrozumieć, jakie zasoby tworzymy. Kurs pokazuje jednak podstawy pracy z każdą z trzech głównych chmur.' },
      { q: 'Czy Terraform jest darmowym narzędziem?', a: 'Tak, sam Terraform (open-source CLI) jest całkowicie darmowy. Płatne mogą być niektóre funkcje platformy Terraform Cloud/Enterprise lub oczywiście zasoby tworzone w chmurze publicznej.' },
      { q: 'Czy kurs obejmuje bardzo zaawansowane scenariusze Terraform?', a: 'Kurs koncentruje się na solidnych podstawach i najważniejszych koncepcjach potrzebnych do samodzielnej pracy z Terraform. Nie wchodzimy w bardzo niszowe lub skomplikowane zastosowania, ale dajemy fundament pod ich naukę.' }
    ]
  },

  // --- IT: Data Science & AI ---
  {
    id: 'python-data-science-bootcamp',
    title: 'Python w Data Science i Machine Learning: Od NumPy do Scikit-learn',
    category: 'Data Science',
    tags: ['python', 'data science', 'machine learning', 'numpy', 'pandas', 'matplotlib', 'seaborn', 'scikit-learn', 'analiza danych', 'wizualizacja danych', 'uczenie maszynowe'],
    imageUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=400', // OK
    price: 299.00,
    originalPrice: 449.00,
    currency: 'PLN',
    rating: 4.9,
    reviews: 2215,
    level: 'średniozaawansowany',
    duration: 'ok. 10-12 godzin materiału i projektów',
    certificate: true,
    bestSeller: true,
    description: 'Kompletny bootcamp Data Science i Machine Learning w Pythonie! Opanuj kluczowe biblioteki: NumPy, Pandas, Matplotlib, Seaborn i Scikit-learn. Naucz się analizować dane, tworzyć wizualizacje i budować modele ML. Mnóstwo praktycznych ćwiczeń i projektów do portfolio.',
    instructor: 'Akademia Danych',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do Data Science i ekosystemu Pythona.',
      'Podstawy Pythona dla Data Science.',
      'Praca z tablicami wielowymiarowymi w NumPy.',
      'Manipulacja danymi w Pandas (Series, DataFrame, wczytywanie, czyszczenie).',
      'Zaawansowane operacje w Pandas (grupowanie, łączenie, tabele przestawne).',
      'Tworzenie podstawowych wykresów z Matplotlib.',
      'Zaawansowane wizualizacje statystyczne z Seaborn.',
      'Wprowadzenie do koncepcji Machine Learning.',
      'Przygotowanie danych do modeli w Scikit-learn (preprocessing).',
      'Budowanie modeli regresyjnych (Regresja Liniowa).',
      'Budowanie modeli klasyfikacyjnych (Regresja Logistyczna, KNN, SVM, Drzewa, Lasy Losowe).',
      'Budowanie modeli klastrowania (K-Means).',
      'Ocena wydajności modeli ML (metryki, walidacja krzyżowa).',
      'Realizacja praktycznego projektu Data Science od A do Z.'
    ],
    forWho: [
      'Dla osób chcących rozpocząć karierę w dziedzinie Data Science, Analizy Danych lub Machine Learning.',
      'Dla analityków biznesowych, finansowych, marketingowych chcących poszerzyć swoje umiejętności o Pythona i techniki ML.',
      'Dla programistów zainteresowanych wykorzystaniem danych do tworzenia inteligentnych aplikacji.',
      'Dla studentów kierunków technicznych, ścisłych i ekonomicznych.',
      'Dla każdego, kto chce nauczyć się efektywnie pracować z danymi, wizualizować je i budować proste modele predykcyjne w Pythonie.'
    ],
    whatYouGet: [
      'Praktyczną biegłość w posługiwaniu się kluczowymi bibliotekami Python do Data Science: NumPy, Pandas, Matplotlib, Seaborn i Scikit-learn.',
      'Umiejętność wczytywania, czyszczenia, przekształcania i analizowania różnorodnych zbiorów danych.',
      'Zdolność tworzenia czytelnych i informatywnych wizualizacji danych.',
      'Solidne zrozumienie podstawowych koncepcji i przepływu pracy w Machine Learning.',
      'Umiejętność budowania, trenowania i oceny podstawowych modeli regresyjnych, klasyfikacyjnych i klastrujących za pomocą Scikit-learn.',
      'Praktyczne doświadczenie zdobyte podczas realizacji ćwiczeń i projektów na realnych danych.',
      'Mocne fundamenty do dalszej, bardziej zaawansowanej nauki w obszarze AI, Deep Learning czy Big Data.',
      'Projekt(y) do umieszczenia w swoim portfolio.'
    ],
    faq: [
      { q: 'Czy potrzebuję zaawansowanej wiedzy matematycznej lub statystycznej?', a: 'Podstawowa znajomość matematyki (szczególnie algebra liniowa na poziomie liceum/początku studiów) i podstaw statystyki jest pomocna, ale kluczowe koncepcje matematyczne i statystyczne stojące za algorytmami są wyjaśniane w sposób przystępny w kursie. Nie musisz być matematykiem.' },
      { q: 'Czy muszę znać Pythona przed rozpoczęciem kursu?', a: 'Tak, kurs zakłada znajomość podstaw programowania w Pythonie (zmienne, typy danych, pętle, warunki, funkcje, podstawy struktur danych jak listy i słowniki). Jest moduł przypominający, ale nie jest to kurs nauki Pythona od zera.' },
      { q: 'Czy kurs obejmuje Deep Learning (Sieci Neuronowe)?', a: 'Nie, ten kurs koncentruje się na "klasycznym" Machine Learning i bibliotece Scikit-learn. Deep Learning (TensorFlow, Keras, PyTorch) to temat na osobny, bardziej zaawansowany kurs.' }
    ]
  },
  {
    id: 'machine-learning-zaawansowany',
    title: 'Zaawansowane Machine Learning i Deep Learning: Od XGBoost do Transformerów',
    category: 'Data Science',
    tags: ['machine learning', 'uczenie maszynowe', 'ai', 'sztuczna inteligencja', 'deep learning', 'głębokie uczenie', 'sieci neuronowe', 'tensorflow', 'keras', 'pytorch', 'xgboost', 'lightgbm', 'nlp', 'przetwarzanie języka naturalnego', 'computer vision', 'wizja komputerowa', 'mlops'],
    imageUrl: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&q=80&w=400', // OK
    price: 449.99,
    originalPrice: 599.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 1100,
    level: 'zaawansowany',
    duration: 'ok. 15-18 godzin materiału i projektów',
    certificate: true,
    bestSeller: true,
    description: 'Wejdź na najwyższy poziom ML i DL! Ten kurs dla zaawansowanych obejmuje potężne algorytmy (XGBoost, LightGBM), głębokie sieci neuronowe (ANN, CNN, RNN) z TF/Keras/PyTorch, podstawy NLP (Word Embeddings, Transformery) i wizji komputerowej (CV) oraz wprowadzenie do MLOps.',
    instructor: 'AI Research Institute & PhD Data Scientist',
    affiliateUrl: '#',
    plan: [
      'Zaawansowane przypomnienie podstaw ML i walidacji modeli.',
      'Algorytmy zespołowe (XGBoost, LightGBM, CatBoost).',
      'Zaawansowana inżynieria i selekcja cech.',
      'Techniki redukcji wymiarowości (PCA, t-SNE, UMAP).',
      'Wprowadzenie do Deep Learning i sieci neuronowych.',
      'Praca z frameworkami Deep Learning (TensorFlow/Keras lub PyTorch).',
      'Konwolucyjne Sieci Neuronowe (CNN) w wizji komputerowej.',
      'Rekurencyjne Sieci Neuronowe (RNN, LSTM, GRU) dla danych sekwencyjnych.',
      'Podstawy Przetwarzania Języka Naturalnego (NLP).',
      'Zaawansowane NLP i modele Transformer (np. BERT).',
      'Zaawansowane techniki uczenia nienadzorowanego.',
      'Optymalizacja hiperparametrów modeli.',
      'Interpretowalność modeli (XAI - SHAP, LIME).',
      'Wprowadzenie do MLOps (cykl życia i wdrażanie modeli).'
    ],
    forWho: [
      'Dla osób posiadających solidne podstawy Machine Learning (znajomość Scikit-learn, proces budowy modelu, metryki oceny).',
      'Dla Data Scientists, Analityków Danych, Inżynierów ML, którzy chcą pogłębić swoją wiedzę o zaawansowane algorytmy i Deep Learning.',
      'Dla programistów zainteresowanych praktycznym zastosowaniem Sztucznej Inteligencji w NLP i CV.',
      'Dla badaczy i studentów studiów magisterskich/doktoranckich związanych z AI/ML.',
      'Dla osób chcących pracować nad złożonymi problemami predykcyjnymi i analitycznymi przy użyciu najnowocześniejszych metod.'
    ],
    whatYouGet: [
      'Dogłębną znajomość i umiejętność stosowania zaawansowanych algorytmów ML, w tym XGBoost i LightGBM.',
      'Umiejętność projektowania, budowania i trenowania różnych typów głębokich sieci neuronowych (ANN, CNN, RNN).',
      'Praktyczną biegłość w pracy z jednym (lub oboma) wiodącymi frameworkami Deep Learning: TensorFlow/Keras lub PyTorch.',
      'Solidne podstawy teoretyczne i praktyczne w dziedzinie Przetwarzania Języka Naturalnego (NLP) i Wizji Komputerowej (CV).',
      'Wiedzę na temat zaawansowanych technik preprocessingu danych, optymalizacji hiperparametrów i oceny modeli.',
      'Zrozumienie podstaw interpretowalności modeli (XAI) i cyklu życia modelu w produkcji (MLOps).',
      'Umiejętność rozwiązywania złożonych problemów z wykorzystaniem AI/ML.',
      'Zaawansowane projekty do portfolio.'
    ],
    faq: [
      { q: 'Czy kurs wymaga bardzo silnego zaplecza matematycznego?', a: 'Tak, aby w pełni zrozumieć działanie algorytmów Deep Learning, wymagana jest solidna znajomość algebry liniowej, rachunku różniczkowego i rachunku prawdopodobieństwa na poziomie akademickim. Kluczowe koncepcje są przypominane, ale kurs zakłada pewien poziom matematycznej dojrzałości.' },
      { q: 'Który framework Deep Learning jest głównym w kursie: TensorFlow/Keras czy PyTorch?', a: 'To zależy od konkretnej edycji kursu. Czasem kurs skupia się na jednym, a czasem pokazuje równolegle oba. Sprawdź dokładny opis modułów kursu lub zapytaj organizatora. Oba frameworki są obecnie bardzo popularne.' },
      { q: 'Czy po tym kursie będę ekspertem AI?', a: 'Kurs daje bardzo solidne, zaawansowane fundamenty i umiejętności praktyczne. Stanie się "ekspertem AI" wymaga jednak dalszej specjalizacji, ciągłej nauki i wieloletniego doświadczenia w rozwiązywaniu realnych problemów.' }
    ]
  },
  {
    id: 'ai-prompt-engineering',
    title: 'Prompt Engineering: Wydobądź Maksimum z AI (ChatGPT, Gemini itp.)',
    category: 'AI',
    tags: ['ai', 'sztuczna inteligencja', 'prompt engineering', 'prompting', 'llm', 'duże modele językowe', 'chatgpt', 'gemini', 'claude', 'generowanie treści', 'automatyzacja zadań', 'kreatywność', 'komunikacja z ai'],
    imageUrl: 'https://images.unsplash.com/photo-1684717729370-56a5a3e8a566?auto=format&fit=crop&q=80&w=400', // Nowy URL - bardziej o komunikacji/języku
    price: 189.00,
    originalPrice: 249.00,
    currency: 'PLN',
    rating: 4.8,
    reviews: 550,
    level: 'początkujący',
    duration: 'ok. 1.5-2 godziny materiału i przykładów',
    certificate: true,
    bestSeller: true,
    description: 'Opanuj sztukę "rozmowy" z AI! Naucz się tworzyć precyzyjne polecenia (prompty) dla modeli jak ChatGPT czy Gemini, by generować dokładnie takie treści, jakich potrzebujesz - teksty, kody, analizy, pomysły. Zwiększ swoją produktywność i kreatywność dzięki Prompt Engineeringowi!',
    instructor: 'AI Explorers & Prompt Crafters',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do LLM i Prompt Engineeringu.',
      'Anatomia skutecznego promptu (rola, kontekst, instrukcja).',
      'Podstawowe techniki promptingu (Zero-shot, Few-shot).',
      'Zaawansowane techniki promptingu (Chain-of-Thought, Self-Consistency).',
      'Tworzenie promptów dla różnych zadań (pisanie, kodowanie, analiza).',
      'Iteracyjne ulepszanie i testowanie promptów.',
      'Unikanie typowych błędów i pułapek (halucynacje AI).',
      'Etyczne aspekty i ograniczenia LLM.',
      'Przyszłość Prompt Engineeringu.'
    ],
    forWho: [
      'Dla każdego, kto regularnie lub sporadycznie korzysta z narzędzi AI takich jak ChatGPT, Gemini, Copilot, Claude itp.',
      'Dla marketerów, copywriterów, twórców treści, którzy chcą generować lepsze teksty i pomysły.',
      'Dla programistów chcących efektywniej wykorzystywać AI do generowania i debugowania kodu.',
      'Dla analityków, badaczy, studentów, którzy chcą używać AI do analizy, podsumowywania i przetwarzania informacji.',
      'Dla przedsiębiorców i pracowników biurowych szukających sposobów na automatyzację zadań i zwiększenie produktywności.',
      'Dla każdej osoby ciekawej potencjału AI i chcącej nauczyć się efektywnie komunikować z maszynami.'
    ],
    whatYouGet: [
      'Zrozumienie jak "myślą" Duże Modele Językowe i jak na nie wpływać za pomocą promptów.',
      'Umiejętność konstruowania precyzyjnych, klarownych i skutecznych poleceń dla AI.',
      'Praktyczną znajomość różnorodnych technik promptingu, od podstawowych po zaawansowane.',
      'Gotowe wzorce i przykłady promptów dla wielu typowych zastosowań zawodowych i prywatnych.',
      'Metodykę testowania i iteracyjnego ulepszania swoich promptów.',
      'Większą kontrolę nad jakością i trafnością odpowiedzi generowanych przez AI.',
      'Świadomość możliwości, ograniczeń i etycznych aspektów korzystania z generatywnej AI.',
      'Znaczące zwiększenie efektywności pracy z narzędziami AI.'
    ],
    faq: [
      { q: 'Czy muszę znać programowanie lub mieć wiedzę techniczną o AI?', a: 'Absolutnie nie! Kurs jest zaprojektowany dla szerokiego grona odbiorców i skupia się na umiejętności komunikacji z AI poprzez język naturalny. Nie wymaga żadnej wiedzy programistycznej.' },
      { q: 'Czy kurs skupia się tylko na ChatGPT?', a: 'Kurs omawia uniwersalne zasady i techniki promptingu, które można zastosować do większości nowoczesnych modeli LLM (jak ChatGPT, Gemini, Claude itp.). Przykłady mogą być pokazywane na różnych modelach, aby zilustrować ich działanie.' },
      { q: 'Czy nauczę się tworzyć własne modele AI?', a: 'Nie, ten kurs uczy jak efektywnie *używać* istniejących modeli AI poprzez umiejętne tworzenie promptów. Nie obejmuje on trenowania ani budowania modeli AI.' }
    ]
  },

  // --- Marketing & Biznes ---
  {
    id: 'marketing-cyfrowy-kompletny',
    title: 'Marketing Cyfrowy 360°: SEO, Google Ads, Social Media, Content Marketing i Analityka',
    category: 'Marketing',
    tags: ['marketing cyfrowy', 'digital marketing', 'marketing internetowy', 'seo', 'pozycjonowanie', 'sem', 'google ads', 'ppc', 'facebook ads', 'instagram ads', 'social media marketing', 'marketing w mediach społecznościowych', 'content marketing', 'marketing treści', 'email marketing', 'google analytics 4', 'ga4', 'analityka internetowa'],
    imageUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=400', // OK
    price: 349.00,
    originalPrice: 499.00,
    currency: 'PLN',
    rating: 4.8,
    reviews: 1750,
    level: 'początkujący',
    duration: 'ok. 12-15 godzin materiału do nauki',
    certificate: true,
    bestSeller: true,
    description: 'Kompletny przewodnik po marketingu online! Opanuj SEO, Google Ads (Search, Display, YouTube, PMax), Facebook & Instagram Ads, Content Marketing, Social Media, Email Marketing i analitykę GA4. Od strategii po realizację i mierzenie efektów - wszystko, czego potrzebujesz do sukcesu w sieci.',
    instructor: 'Akademia Marketingu Online (Certyfikowani Specjaliści)',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do marketingu cyfrowego i tworzenie strategii.',
      'Podstawy SEO (optymalizacja pod wyszukiwarki).',
      'Kampanie Google Ads w sieci wyszukiwania.',
      'Kampanie Google Ads w sieci reklamowej i YouTube.',
      'Reklama na Facebooku i Instagramie (Meta Ads).',
      'Planowanie, tworzenie i dystrybucja treści (Content Marketing).',
      'Strategie marketingowe w mediach społecznościowych.',
      'Budowanie bazy i automatyzacja w Email Marketingu.',
      'Konfiguracja i analiza danych w Google Analytics 4.',
      'Mierzenie efektywności działań marketingowych (KPI, ROI).',
      'Integracja kanałów i najnowsze trendy.'
    ],
    forWho: [
      'Dla osób aspirujących do roli Specjalisty ds. Marketingu Cyfrowego / Digital Marketera.',
      'Dla przedsiębiorców i właścicieli małych firm, którzy chcą samodzielnie promować swój biznes online.',
      'Dla tradycyjnych marketerów chcących zdobyć kompleksową wiedzę o działaniach w internecie.',
      'Dla specjalistów z innych dziedzin (np. sprzedaży, PR, IT), którzy chcą zrozumieć marketing cyfrowy.',
      'Dla studentów marketingu, zarządzania i kierunków pokrewnych.',
      'Dla każdego, kto chce skutecznie budować widoczność i pozyskiwać klientów w internecie.'
    ],
    whatYouGet: [
      'Kompleksową i ustrukturyzowaną wiedzę o wszystkich głównych kanałach i narzędziach marketingu cyfrowego.',
      'Umiejętność tworzenia i wdrażania spójnej strategii marketingowej online.',
      'Praktyczną biegłość w obsłudze kluczowych platform reklamowych (Google Ads, Meta Ads).',
      'Solidne zrozumienie zasad SEO i umiejętność podstawowej optymalizacji strony.',
      'Wiedzę na temat planowania, tworzenia i dystrybucji wartościowych treści (Content Marketing).',
      'Umiejętność konfiguracji i analizy danych w Google Analytics 4 do mierzenia efektów działań.',
      'Zdolność do efektywnego zarządzania profilami w mediach społecznościowych i prowadzenia kampanii email marketingowych.',
      'Certyfikat potwierdzający zdobyte, szerokie kompetencje w marketingu cyfrowym.'
    ],
    faq: [
      { q: 'Czy potrzebuję własnej strony internetowej lub firmy, aby skorzystać z kursu?', a: 'Nie jest to absolutnie wymagane. Kurs omawia koncepcje i narzędzia w sposób uniwersalny. Ćwiczenia można wykonywać na przykładach, kontach demonstracyjnych (np. GA4) lub darmowych kontach reklamowych z minimalnym budżetem.' },
      { q: 'Czy ten kurs przygotowuje do oficjalnych certyfikatów Google Ads lub Meta Blueprint?', a: 'Kurs dostarcza wiedzy i umiejętności potrzebnych do zdania tych egzaminów, pokrywając wymagany zakres materiału. Nie jest to jednak oficjalny kurs przygotowawczy autoryzowany przez Google czy Meta.' },
      { q: 'Czy poziom jest odpowiedni dla osoby zupełnie początkującej?', a: 'Tak, kurs jest zaprojektowany tak, aby prowadzić od podstaw w każdym z omawianych obszarów. Nie jest wymagana wcześniejsza wiedza marketingowa, choć podstawowa znajomość obsługi komputera i internetu jest niezbędna.' }
    ]
  },
  {
    id: 'excel-dla-biznesu-mistrz',
    title: 'Excel w Biznesie: Od Początkującego do Mistrza (Formuły, Power Query, VBA)',
    category: 'Biznes',
    tags: ['excel', 'ms excel', 'arkusz kalkulacyjny', 'analiza danych', 'biznes', 'raportowanie', 'dashboardy', 'formuły excel', 'funkcje excel', 'tabele przestawne', 'power query', 'vba', 'makra excel', 'automatyzacja', 'wizualizacja danych'],
    imageUrl: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&q=80&w=400', // OK
    price: 279.99,
    originalPrice: 349.99,
    currency: 'PLN',
    rating: 4.9,
    reviews: 2500,
    level: 'początkujący',
    duration: 'ok. 10-13 godzin materiału i ćwiczeń',
    certificate: true,
    bestSeller: true,
    description: 'Kompleksowy kurs Excela dla każdego! Niezależnie od poziomu, doprowadzimy Cię do mistrzostwa. Opanujesz formuły, funkcje, Tabele Przestawne, potężne Power Query do transformacji danych, tworzenie Dashboardów i automatyzację zadań za pomocą Makr VBA. Zrewolucjonizuj swoją pracę z danymi!',
    instructor: 'Excel Guru Polska (MVP & Trener Biznesu)',
    affiliateUrl: '#',
    plan: [
      'Fundamenty Excela (interfejs, formuły, funkcje, formatowanie).',
      'Praca z danymi (sortowanie, filtrowanie, tabele).',
      'Analiza danych za pomocą Tabel Przestawnych.',
      'Profesjonalna wizualizacja danych (wykresy).',
      'Import i transformacja danych z Power Query.',
      'Tworzenie interaktywnych dashboardów menedżerskich.',
      'Wprowadzenie do automatyzacji z VBA (makra).',
      'Podstawy programowania w VBA dla Excela.',
      'Zaawansowane techniki i triki.'
    ],
    forWho: [
      'Dla pracowników biurowych z każdej branży (finanse, księgowość, HR, marketing, sprzedaż, logistyka).',
      'Dla analityków danych, kontrolerów finansowych, specjalistów ds. raportowania.',
      'Dla managerów i liderów zespołów, którzy chcą lepiej rozumieć i prezentować dane.',
      'Dla studentów kierunków ekonomicznych, technicznych i zarządzania.',
      'Dla każdego, kto chce znacząco usprawnić swoją pracę z danymi, zautomatyzować zadania i tworzyć profesjonalne raporty w Excelu.'
    ],
    whatYouGet: [
      'Kompleksową wiedzę i praktyczną biegłość w posługiwaniu się programem MS Excel na każdym poziomie zaawansowania.',
      'Opanowanie najważniejszych i najczęściej używanych funkcji i formuł Excela.',
      'Mistrzostwo w tworzeniu i wykorzystaniu Tabel Przestawnych do błyskawicznej analizy danych.',
      'Umiejętność tworzenia profesjonalnych i czytelnych wykresów oraz interaktywnych dashboardów.',
      'Praktyczną znajomość Power Query do efektywnego importu i transformacji danych z różnych źródeł.',
      'Solidne podstawy programowania w VBA, pozwalające na automatyzację powtarzalnych zadań.',
      'Znaczne przyspieszenie i zwiększenie efektywności codziennej pracy z arkuszami kalkulacyjnymi.',
      'Certyfikat potwierdzający zdobycie szerokich kompetencji w zakresie Excela.'
    ],
    faq: [
      { q: 'Jakiej wersji Excela potrzebuję, aby skorzystać z kursu?', a: 'Kurs jest oparty głównie na funkcjach dostępnych w nowszych wersjach Excela (Microsoft 365, 2021, 2019, 2016). Starsze wersje (np. 2013, 2010) mogą nie posiadać niektórych omawianych narzędzi (szczególnie Power Query i nowszych funkcji jak X.WYSZUKAJ). VBA jest dostępne we wszystkich tych wersjach.' },
      { q: 'Czy kurs jest odpowiedni dla użytkowników Excela na Macu?', a: 'Większość funkcji i formuł Excela działa bardzo podobnie lub identycznie na systemach Windows i macOS. Jednak interfejs może się nieznacznie różnić, a niektóre zaawansowane funkcje (zwłaszcza w Power Query i VBA) mogą mieć ograniczenia lub działać inaczej na Macu. Kurs jest nagrywany na wersji Windows.' },
      { q: 'Czy muszę znać podstawy Excela, żeby zacząć?', a: 'Nie, kurs zaczyna się od absolutnych podstaw (Moduły 1-5), więc jest odpowiedni również dla osób, które nigdy wcześniej nie pracowały z Excelem.' }
    ]
  },
  {
    id: 'zarzadzanie-projektami-agile',
    title: 'Agile, Scrum i Kanban w Zarządzaniu Projektami: Praktyczny Kurs',
    category: 'Zarządzanie',
    tags: ['zarządzanie projektami', 'project management', 'agile', 'metodyki zwinne', 'scrum', 'kanban', 'product owner', 'scrum master', 'zespół deweloperski', 'proces wytwórczy', 'produktywność zespołu', 'jira', 'trello'],
    imageUrl: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=400', // OK
    price: 249.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 1150,
    level: 'średniozaawansowany',
    duration: 'ok. 5-7 godzin materiału i zadań',
    certificate: true,
    bestSeller: true,
    description: 'Opanuj zwinne zarządzanie projektami! Poznaj filozofię Agile, framework Scrum (role, wydarzenia, artefakty) i metodę Kanban. Ten praktyczny kurs nauczy Cię stosować te podejścia, by zwiększyć efektywność zespołu, szybciej dostarczać wartość i lepiej reagować na zmiany.',
    instructor: 'Certyfikowany Agile Coach & Scrum Professional',
    affiliateUrl: '#',
    plan: [
      'Porównanie tradycyjnego i zwinnego zarządzania projektami.',
      'Wartości i zasady Manifestu Agile.',
      'Role w Scrum (Product Owner, Scrum Master, Zespół).',
      'Wydarzenia Scrum (Sprint, Planning, Daily, Review, Retrospective).',
      'Artefakty Scrum (Backlog Produktu/Sprintu, Przyrost).',
      'Zarządzanie Backlogiem Produktu (User Stories, Priorytetyzacja).',
      'Metoda Kanban (Zasady, Praktyki, Tablica, Metryki).',
      'Porównanie i zastosowanie Scrum vs Kanban.',
      'Przegląd narzędzi wspierających Agile (Jira, Trello).',
      'Podstawy skalowania Agile (SAFe, LeSS).',
      'Wdrażanie Agile w organizacji i budowanie kultury zwinnej.'
    ],
    forWho: [
      'Dla Project Managerów i Product Managerów chcących poznać lub usystematyzować wiedzę o Agile.',
      'Dla Liderów Zespołów, Scrum Masterów (aspirujących i obecnych) oraz Product Ownerów.',
      'Dla członków zespołów deweloperskich (programistów, testerów, analityków), którzy pracują lub będą pracować w metodykach zwinnych.',
      'Dla managerów i dyrektorów chcących zrozumieć zasady działania zwinnych zespołów.',
      'Dla osób z różnych branż (nie tylko IT), które chcą zastosować zwinne podejście do zarządzania projektami i pracą.',
      'Dla każdego, kto pracuje w dynamicznym, szybko zmieniającym się środowisku projektowym.'
    ],
    whatYouGet: [
      'Głębokie zrozumienie filozofii Agile, jej wartości i zasad.',
      'Kompleksową i praktyczną znajomość najpopularniejszego frameworka zwinnego - Scrum.',
      'Umiejętność stosowania metody Kanban do wizualizacji i zarządzania przepływem pracy.',
      'Szczegółową wiedzę o kluczowych rolach, wydarzeniach i artefaktach w Scrum.',
      'Zrozumienie podstawowych metryk wykorzystywanych w metodykach zwinnych.',
      'Przegląd popularnych narzędzi wspierających pracę w Agile.',
      'Wiedzę o podstawach skalowania Agile i wyzwaniach związanych z jego wdrażaniem.',
      'Gotowość do efektywnej pracy w zwinnym środowisku projektowym.'
    ],
    faq: [
      { q: 'Czy ten kurs przygotowuje do oficjalnych certyfikatów Scrum (np. PSM I, CSM)?', a: 'Kurs dostarcza kompleksowej wiedzy teoretycznej i praktycznej zgodnej z zakresem tych certyfikatów, co znacząco ułatwi przygotowanie do egzaminu. Nie jest to jednak oficjalny, akredytowany kurs przygotowawczy oferowany przez Scrum.org czy Scrum Alliance.' },
      { q: 'Czy potrzebuję wcześniejszego doświadczenia w zarządzaniu projektami?', a: 'Kurs jest zrozumiały nawet dla osób bez formalnego doświadczenia w PM, ale pewna znajomość realiów pracy projektowej lub zespołowej będzie pomocna w lepszym zrozumieniu kontekstu omawianych metodyk.' },
      { q: 'Czy Agile stosuje się tylko w IT?', a: 'Choć Agile wywodzi się z branży IT, jego zasady i praktyki (szczególnie Kanban) są z powodzeniem adaptowane w wielu innych dziedzinach, takich jak marketing, HR, badania i rozwój, a nawet produkcja.' }
    ]
  },

  // --- Rozwój osobisty i Umiejętności miękkie ---
  {
    id: 'produktywnosc-zarzadzanie-czasem',
    title: 'Mistrz Produktywności: Zarządzaj Czasem, Zadaniami i Energią Skutecznie',
    category: 'Rozwój osobisty',
    tags: ['produktywność', 'zarządzanie czasem', 'organizacja pracy', 'planowanie', 'cele', 'nawyki', 'prokrastynacja', 'odkładanie na później', 'skupienie', 'deep work', 'gtd', 'pomodoro', 'efektywność osobista'],
    imageUrl: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?auto=format&fit=crop&q=80&w=400', // OK
    price: 149.99,
    currency: 'PLN',
    rating: 4.9,
    reviews: 1900,
    level: 'początkujący',
    duration: 'ok. 3-4 godziny materiału + workbook',
    certificate: true,
    bestSeller: true,
    description: 'Pokonaj prokrastynację i odzyskaj kontrolę nad swoim dniem! Ten kurs to przewodnik po najlepszych technikach zarządzania czasem, zadaniami i energią. Naucz się wyznaczać cele, priorytetyzować (Macierz Eisenhowera), planować, stosować metody skupienia (Pomodoro, Deep Work) i budować produktywne nawyki. Realizuj to, co ważne!',
    instructor: 'Certyfikowany Coach Produktywności',
    affiliateUrl: '#',
    plan: [
      'Diagnoza produktywności i identyfikacja "złodziei czasu".',
      'Wyznaczanie celów SMART i planowanie długoterminowe.',
      'Metody priorytetyzacji zadań (Macierz Eisenhowera, ABCDE).',
      'Planowanie dnia i tygodnia (Time Blocking, listy zadań).',
      'Podstawy systemu zarządzania zadaniami Getting Things Done (GTD).',
      'Techniki zwiększania skupienia (Pomodoro, Deep Work).',
      'Budowanie produktywnych nawyków i rutyn.',
      'Zrozumienie i pokonywanie prokrastynacji.',
      'Zarządzanie energią (rola odpoczynku i regeneracji).',
      'Przegląd narzędzi cyfrowych wspierających produktywność.',
      'Utrzymanie systemu produktywności w długim terminie.'
    ],
    forWho: [
      'Dla osób czujących się wiecznie zajętymi, ale mało efektywnymi.',
      'Dla studentów, freelancerów, pracowników umysłowych i przedsiębiorców.',
      'Dla tych, którzy chcą skuteczniej realizować swoje cele zawodowe i prywatne.',
      'Dla osób zmagających się z prokrastynacją i brakiem motywacji.',
      'Dla każdego, kto chce odzyskać kontrolę nad swoim czasem, zwiększyć skupienie i poczuć większą satysfakcję z działania.'
    ],
    whatYouGet: [
      'Zestaw sprawdzonych, praktycznych metod zarządzania czasem, zadaniami i energią.',
      'Umiejętność wyznaczania klarownych, mierzalnych celów i tworzenia planów ich realizacji.',
      'Skuteczne techniki priorytetyzacji, które pomogą Ci skupić się na tym, co najważniejsze.',
      'Sposoby na zwiększenie koncentracji, ograniczenie rozpraszaczy i wejście w stan "deep work".',
      'Wiedzę o mechanizmach prokrastynacji i konkretne narzędzia do jej pokonywania.',
      'Praktyczne wskazówki dotyczące budowania i utrzymywania produktywnych nawyków.',
      'Przegląd przydatnych narzędzi cyfrowych, które mogą wesprzeć Twój system produktywności.',
      'Większą kontrolę nad swoim dniem, mniejszy stres i większe poczucie sprawczości.'
    ],
    faq: [
      { q: 'Czy muszę używać konkretnych, płatnych aplikacji polecanych w kursie?', a: 'Kurs omawia różne popularne narzędzia (wiele z nich ma darmowe plany), ale skupia się na uniwersalnych metodach i zasadach. Możesz je wdrożyć, korzystając z dowolnych narzędzi, które preferujesz - nawet z tradycyjnego papierowego kalendarza i notatnika.' },
      { q: 'Czy kurs jest odpowiedni dla osób z ADHD?', a: 'Techniki zarządzania czasem i zadaniami omawiane w kursie mogą być pomocne dla niektórych osób z ADHD w budowaniu struktury i organizacji. Kurs nie jest jednak terapią ani specjalistycznym poradnikiem dedykowanym wyłącznie osobom z ADHD i nie zastąpi profesjonalnej pomocy.' },
      { q: 'Czy te metody działają od razu?', a: 'Wdrożenie nowych metod i nawyków wymaga czasu i konsekwencji. Kurs dostarcza narzędzi i planu działania, ale efekty zależą od Twojego zaangażowania w praktyczne stosowanie poznanych technik.' }
    ]
  },
  {
    id: 'inteligencja-emocjonalna-eq',
    title: 'Inteligencja Emocjonalna (EQ): Klucz do Sukcesu w Pracy i Życiu',
    category: 'Rozwój osobisty',
    tags: ['inteligencja emocjonalna', 'eq', 'emocje', 'zarządzanie emocjami', 'samoświadomość', 'samoregulacja', 'empatia', 'umiejętności społeczne', 'relacje interpersonalne', 'komunikacja', 'radzenie sobie ze stresem', 'motywacja', 'przywództwo'],
    imageUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=400', // OK
    price: 199.99,
    currency: 'PLN',
      rating: 4.8,
    reviews: 850,
    level: 'początkujący',
    duration: 'ok. 3-4 godziny materiału i ćwiczeń',
    certificate: true,
    bestSeller: false,
    description: 'Rozwiń inteligencję emocjonalną (EQ) - kluczową kompetencję XXI wieku! Naucz się rozpoznawać i zarządzać emocjami (swoimi i innych), rozwijaj empatię, buduj lepsze relacje, skuteczniej komunikuj się i radź sobie ze stresem. Kurs dla każdego, kto chce odnosić sukcesy w pracy i życiu osobistym.',
    instructor: 'Psycholog Biznesu i Certyfikowany Coach EQ',
    affiliateUrl: '#',
    plan: [
      'Czym jest inteligencja emocjonalna i dlaczego jest ważna?',
      'Rozpoznawanie i nazywanie własnych emocji (samoświadomość).',
      'Zarządzanie emocjami i impulsami (samoregulacja).',
      'Budowanie motywacji wewnętrznej.',
      'Rozwijanie empatii i rozumienia innych.',
      'Kluczowe umiejętności społeczne (komunikacja, budowanie relacji).',
      'Inteligencja emocjonalna w miejscu pracy (przywództwo, zespół).',
      'Strategie radzenia sobie ze stresem i budowanie odporności.',
      'Wpływ EQ na podejmowanie decyzji.',
      'Tworzenie własnego planu rozwoju EQ.'
    ],
    forWho: [
      'Dla każdego, kto chce lepiej rozumieć siebie i innych.',
      'Dla liderów i managerów chcących budować zaangażowane zespoły.',
      'Dla osób pracujących w obsłudze klienta, sprzedaży, HR.',
      'Dla każdego, kto chce poprawić swoje relacje i komunikację.',
      'Dla osób chcących skuteczniej radzić sobie ze stresem.'
    ],
    whatYouGet: [
      'Głębsze zrozumienie własnych emocji i ich wpływu na zachowanie.',
      'Umiejętność zarządzania emocjami i reakcjami.',
      'Zwiększoną empatię i zdolność rozumienia innych.',
      'Poprawę kluczowych umiejętności komunikacyjnych i budowania relacji.',
      'Skuteczniejsze strategie radzenia sobie ze stresem.',
      'Praktyczne narzędzia do ciągłego rozwoju inteligencji emocjonalnej.'
    ],
    faq: [
      { q: 'Czy kurs opiera się na naukowych podstawach?', a: 'Tak, kurs bazuje na uznanych modelach inteligencji emocjonalnej (np. Golemana) i badaniach psychologicznych.' },
      { q: 'Czy rozwój EQ jest możliwy w każdym wieku?', a: 'Tak, inteligencja emocjonalna jest umiejętnością, którą można rozwijać przez całe życie.' },
      { q: 'Czy kurs zawiera ćwiczenia praktyczne?', a: 'Tak, kurs zawiera liczne ćwiczenia praktyczne, pytania do refleksji i scenariusze, które pomagają zastosować omawiane koncepcje w Twoim własnym życiu i pracy.' }
    ]
  },
  {
    id: 'detoks-cyfrowy-koncentracja',
    title: 'Cyfrowy Detoks: Odzyskaj Skupienie i Kontrolę nad Uwagą',
    category: 'Rozwój osobisty',
    tags: ['detoks cyfrowy', 'higiena cyfrowa', 'minimalizm cyfrowy', 'koncentracja', 'skupienie', 'deep work', 'mindfulness', 'uważność', 'produktywność', 'technologia', 'uzależnienie od telefonu', 'social media detox', 'przebodźcowanie'],
    imageUrl: 'https://images.unsplash.com/photo-1542671036-c169185e26a4?auto=format&fit=crop&q=80&w=400', // Nowy URL - wyciszenie/offline
    price: 169.99,
    currency: 'PLN',
      rating: 4.7,
    reviews: 980,
    level: 'początkujący',
    duration: 'ok. 2-3 godziny materiału + plan',
    certificate: true,
    bestSeller: false,
    description: 'Czujesz się przebodźcowany i rozproszony? Ten kurs pomoże Ci odzyskać kontrolę nad technologią i uwagą. Naucz się diagnozować cyfrowe nawyki, wdrażać strategie detoksu, ograniczać social media i trenować głęboką koncentrację (`deep work`). Żyj bardziej świadomie w cyfrowym świecie!',
    instructor: 'Mindfulness Coach & Digital Wellness Expert',
    affiliateUrl: '#',
    textOnly: false,
    plan: [
      'Jak technologia wpływa na mózg i uwagę?',
      'Audyt cyfrowy - diagnoza własnych nawyków.',
      'Strategie ograniczania czasu ekranowego.',
      'Zarządzanie powiadomieniami i social media.',
      'Trening koncentracji i techniki mindfulness.',
      'Koncepcja i praktyka Pracy Głębokiej (Deep Work).',
      'Budowanie zdrowych nawyków cyfrowych.',
      'Znaczenie i planowanie czasu offline.'
    ],
    forWho: [
      'Dla osób czujących się przebodźcowanych, zmęczonych ciągłym napływem informacji i powiadomień.',
      'Dla tych, którzy mają trudności z koncentracją, łatwo się rozpraszają i odkładają zadania wymagające skupienia.',
      'Dla osób chcących ograniczyć bezproduktywny czas spędzany na smartfonie i w mediach społecznościowych.',
      'Dla pracowników umysłowych, studentów, twórców, którzy chcą zwiększyć swoją produktywność i jakość pracy.',
      'Dla każdego, kto chce odzyskać kontrolę nad swoją uwagą, zredukować cyfrowy stres i żyć bardziej świadomie.',
      'Dla rodziców zaniepokojonych wpływem technologii na ich dzieci (choć kurs jest dla dorosłych, zasady są uniwersalne).'
    ],
    whatYouGet: [
      'Głębsze zrozumienie wpływu technologii na Twój mózg, koncentrację i samopoczucie.',
      'Praktyczne, łatwe do wdrożenia strategie ograniczania cyfrowych rozpraszaczy i zarządzania czasem ekranowym.',
      'Konkretne techniki i ćwiczenia mindfulness do treningu umiejętności skupienia i uważności.',
      'Wiedzę o koncepcji "Pracy Głębokiej" (`Deep Work`) i sposobach na jej implementację w codziennym życiu.',
      'Indywidualny plan budowania zdrowych nawyków cyfrowych i utrzymania równowagi.',
      'Większą świadomość i kontrolę nad tym, jak i kiedy korzystasz z technologii.',
      'Poprawę koncentracji, zwiększenie produktywności w zadaniach wymagających skupienia i redukcję stresu.',
      'Więcej czasu i energii na działania offline, które są dla Ciebie ważne.'
    ],
    faq: [
      { q: 'Czy muszę całkowicie rezygnować ze smartfona i mediów społecznościowych?', a: 'Absolutnie nie! Celem kursu nie jest demonizowanie technologii, ale nauczenie się świadomego, celowego i zdrowego korzystania z niej, tak aby nam służyła, a nie szkodziła. Chodzi o równowagę i kontrolę.' },
      { q: 'Czy ten kurs jest oparty na badaniach naukowych?', a: 'Tak, kurs czerpie wiedzę z badań nad neurobiologią uwagi, psychologią poznawczą, wpływem technologii na mózg oraz opiera się na koncepcjach takich jak "Deep Work" Cala Newporta czy zasadach mindfulness.' },
      { q: 'Mam bardzo absorbującą pracę, czy znajdę czas na ten kurs i wdrażanie zmian?', a: 'Kurs jest podzielony na krótkie moduły, a wiele strategii można wdrażać stopniowo, małymi krokami. Inwestycja czasu w naukę tych umiejętności często zwraca się wielokrotnie poprzez zwiększoną efektywność i odzyskany czas w przyszłości.' }
    ]
  },

  // --- Kursy Niszowe / Specjalistyczne (przykłady) ---
  {
    id: 'specjalista-ochrona-srodowiska',
    title: 'Specjalista Ochrony Środowiska: Prawo i Praktyka w Firmie',
    category: 'Środowisko',
    tags: ['ochrona środowiska', 'ekologia', 'prawo ochrony środowiska', 'pozwolenia środowiskowe', 'decyzje środowiskowe', 'gospodarka odpadami', 'bdo', 'raportowanie środowiskowe', 'iso 14001', 'audyt środowiskowy', 'emisje', 'opłaty środowiskowe'],
    imageUrl: 'https://images.unsplash.com/photo-1472214103451-9374bd1c798e?auto=format&fit=crop&q=80&w=400', // OK
    price: 349.99,
    originalPrice: 449.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 550,
    level: 'średniozaawansowany',
    duration: 'ok. 8-10 godzin materiału (czytanie + PDF)',
    certificate: true,
    bestSeller: false,
    description: 'Kompleksowy kurs dla specjalistów ds. ochrony środowiska. Zdobądź wiedzę o prawie (PL/UE), obowiązkach firm, pozwoleniach, gospodarce odpadami (BDO), ochronie powietrza, ISO 14001 i audytach. Niezbędnik w pracy specjalisty i osób odpowiedzialnych za środowisko w organizacji.',
    instructor: 'EkoPrawo Konsulting (Prawnicy i Eksperci Środowiskowi)',
    affiliateUrl: '#',
    plan: [
      'System prawny ochrony środowiska w Polsce i UE.',
      'Pozwolenia zintegrowane i sektorowe.',
      'Decyzje o środowiskowych uwarunkowaniach (DUŚ, OOŚ).',
      'Gospodarka odpadami (klasyfikacja, obowiązki, BDO).',
      'Ochrona powietrza (emisje, opłaty, sprawozdawczość).',
      'Gospodarka wodno-ściekowa (pozwolenia, opłaty).',
      'Ochrona przed hałasem i promieniowaniem.',
      'System Zarządzania Środowiskowego ISO 14001.',
      'Audyt środowiskowy - rodzaje i metodyka.',
      'Opłaty środowiskowe i sprawozdawczość (KOBIZE, GUS).',
      'Odpowiedzialność prawna w ochronie środowiska.'
    ],
    forWho: [
      'Dla osób pracujących lub chcących pracować na stanowisku Specjalisty ds. Ochrony Środowiska w firmach produkcyjnych, usługowych, deweloperskich.',
      'Dla pracowników administracji publicznej zajmujących się ochroną środowiska.',
      'Dla audytorów i konsultantów środowiskowych.',
      'Dla osób odpowiedzialnych za wdrożenie i utrzymanie systemu ISO 14001.',
      'Dla studentów kierunków związanych z ochroną środowiska, inżynierią środowiska, prawem.',
      'Dla przedsiębiorców chcących zrozumieć swoje obowiązki środowiskowe.'
    ],
    whatYouGet: [
      'Kompleksową znajomość kluczowych przepisów prawa ochrony środowiska i ich praktycznej interpretacji.',
      'Umiejętność identyfikacji obowiązków środowiskowych przedsiębiorstwa.',
      'Wiedzę na temat procedur uzyskiwania niezbędnych pozwoleń i decyzji środowiskowych.',
      'Praktyczną znajomość zasad gospodarki odpadami, w tym obsługi systemu BDO.',
      'Zrozumienie wymagań normy ISO 14001 i podstaw przeprowadzania audytów środowiskowych.',
      'Umiejętność przygotowania wymaganej sprawozdawczości i naliczania opłat środowiskowych.',
      'Świadomość potencjalnych ryzyk i sankcji związanych z nieprzestrzeganiem przepisów.',
      'Solidne podstawy do pracy na stanowisku specjalisty ds. ochrony środowiska.'
    ],
    faq: [
      { q: 'Czy kurs uwzględnia najnowsze zmiany w prawie ochrony środowiska?', a: 'Staramy się na bieżąco aktualizować materiały, aby odzwierciedlały aktualny stan prawny. Prawo ochrony środowiska jest jednak dynamiczne, dlatego zawsze warto weryfikować kluczowe informacje w oficjalnych źródłach.' },
      { q: 'Czy kurs jest przydatny dla osób bez wykształcenia kierunkowego?', a: 'Tak, kurs jest pomyślany tak, aby osoby z różnych branż mogły zrozumieć obowiązki środowiskowe. Wymaga jednak zaangażowania w naukę dość specjalistycznej tematyki prawnej i technicznej.' },
      { q: 'Czy kurs przygotowuje do konkretnych egzaminów państwowych?', a: 'Kurs dostarcza wiedzy wymaganej w pracy specjalisty ds. ochrony środowiska, która może być przydatna w różnych procesach kwalifikacyjnych, ale nie jest bezpośrednim kursem przygotowującym do konkretnego egzaminu państwowego (jeśli taki istnieje).' }
    ]
  },

  // --- NOWE KURSY DODANE ---
  {
    id: 'ai-dla-kreatywnych',
    title: 'AI dla Kreatywnych: Twórz Grafiki i Treści (Midjourney, DALL-E)',
    category: 'AI',
    tags: ['ai', 'sztuczna inteligencja', 'midjourney', 'dall-e', 'generowanie obrazów', 'grafika ai', 'tworzenie treści', 'kreatywność', 'marketing wizualny', 'projektowanie graficzne'],
    imageUrl: 'https://images.unsplash.com/photo-1678043635103-6f50189b5c95?auto=format&fit=crop&q=80&w=400', // OK
    price: 219.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 420,
    level: 'początkujący',
    duration: 'ok. 3-4 godziny materiału i przykładów',
    certificate: true,
    bestSeller: true,
    description: 'Uwolnij kreatywność z AI! Naucz się generować niesamowite obrazy, grafiki i inspiracje wizualne za pomocą narzędzi takich jak Midjourney czy DALL-E. Ten kurs pokaże Ci, jak tworzyć skuteczne prompty, eksplorować różne style i wykorzystywać grafikę AI w marketingu, social mediach i projektach kreatywnych – bez umiejętności rysowania!',
    instructor: 'Artysta AI & Ekspert Narzędzi Kreatywnych',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do generatywnej AI dla obrazów.',
      'Przegląd popularnych narzędzi (Midjourney, DALL-E, Stable Diffusion).',
      'Podstawy tworzenia promptów dla generatorów obrazów.',
      'Techniki zaawansowane (parametry, style, referencje).',
      'Generowanie grafik na potrzeby social media i marketingu.',
      'Wykorzystanie AI do tworzenia inspiracji i moodboardów.',
      'Aspekty prawne i etyczne używania grafik AI.',
      'Praktyczne ćwiczenia i generowanie własnych prac.'
    ],
    forWho: [
      'Marketerzy i specjaliści social media.',
      'Graficy i projektanci szukający nowych narzędzi.',
      'Twórcy treści, blogerzy, influencerzy.',
      'Właściciele małych firm potrzebujący materiałów wizualnych.',
      'Osoby kreatywne chcące eksperymentować z AI.'
    ],
    whatYouGet: [
      'Zrozumienie jak działają generatory obrazów AI.',
      'Umiejętność tworzenia skutecznych promptów w Midjourney/DALL-E.',
      'Praktyczne zastosowania grafiki AI w marketingu i projektach.',
      'Inspirację i umiejętność generowania unikalnych wizualizacji.',
      'Wiedzę o możliwościach i ograniczeniach narzędzi AI.'
    ],
    faq: [
      { q: 'Czy potrzebuję płatnych narzędzi?', a: 'Kurs omawia narzędzia, które mają plany darmowe z ograniczeniami lub płatne subskrypcje (np. Midjourney). Można zacząć od wersji darmowych/trial.' },
      { q: 'Czy muszę umieć rysować?', a: 'Absolutnie nie! Kurs jest dla każdego, niezależnie od umiejętności plastycznych.' }
    ]
  },
  {
    id: 'ai-w-marketingu',
    title: 'AI w Marketingu: Automatyzuj Kampanie i Zwiększaj Wyniki',
    category: 'Marketing',
    tags: ['ai', 'sztuczna inteligencja', 'marketing', 'marketing cyfrowy', 'automatyzacja marketingu', 'personalizacja', 'analiza danych', 'generowanie treści', 'optymalizacja kampanii', 'chatgpt w marketingu'],
    imageUrl: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&q=80&w=400', // OK
    price: 259.99,
    originalPrice: 339.99,
    currency: 'PLN',
    rating: 4.7,
    reviews: 390,
    level: 'średniozaawansowany',
    duration: 'ok. 4-5 godzin materiału',
    certificate: true,
    bestSeller: false,
    description: 'Wykorzystaj moc AI w swoich działaniach marketingowych! Ten kurs pokaże Ci praktyczne zastosowania sztucznej inteligencji do: analizy danych klientów, tworzenia person, generowania chwytliwych tekstów reklamowych i postów, personalizacji komunikacji e-mail, optymalizacji budżetów i automatyzacji powtarzalnych zadań. Pracuj mądrzej, nie ciężej!',
    instructor: 'Digital Marketing Strategist & AI Enthusiast',
    affiliateUrl: '#',
    plan: [
      'Przegląd narzędzi AI przydatnych w marketingu.',
      'Wykorzystanie AI do analizy rynku i konkurencji.',
      'Generowanie person i segmentacja klientów z pomocą AI.',
      'Tworzenie treści marketingowych (copywriting AI).',
      'Personalizacja kampanii email marketingowych.',
      'Optymalizacja kampanii reklamowych (Google Ads, Meta Ads) z AI.',
      'Automatyzacja zadań marketingowych.',
      'Chatboty AI w obsłudze klienta i sprzedaży.',
      'Analiza danych marketingowych z wykorzystaniem AI.',
      'Etyczne aspekty stosowania AI w marketingu.'
    ],
    forWho: [
      'Marketerzy cyfrowi i specjaliści social media.',
      'Managerowie marketingu i właściciele firm.',
      'Specjaliści e-commerce.',
      'Analitycy danych marketingowych.',
      'Osoby chcące zautomatyzować i usprawnić swoje działania marketingowe.'
    ],
    whatYouGet: [
      'Przegląd praktycznych narzędzi AI dla marketerów.',
      'Umiejętność wykorzystania AI do generowania treści i analizy danych.',
      'Strategie personalizacji i automatyzacji kampanii.',
      'Pomysły na optymalizację działań marketingowych.',
      'Wiedzę o możliwościach i ograniczeniach AI w marketingu.'
    ],
    faq: [
      { q: 'Czy potrzebuję wiedzy technicznej o AI?', a: 'Nie, kurs skupia się na praktycznym wykorzystaniu dostępnych narzędzi, bez zagłębiania się w skomplikowaną teorię AI.' },
      { q: 'Czy kurs poleca konkretne płatne narzędzia?', a: 'Omawiamy różne narzędzia, zarówno darmowe, jak i płatne, pokazując ich możliwości.' }
    ]
  },
  {
    id: 'zostan-freelancerem',
    title: 'Zostań Freelancerem i Zarabiaj Online: Kompletny Przewodnik 2024',
    category: 'Freelancing',
    tags: ['freelancing', 'praca zdalna', 'zarabianie online', 'upwork', 'fiverr', 'własna firma', 'zdobywanie klientów', 'portfolio', 'biznes online', 'samozatrudnienie', 'praca w domu'],
    imageUrl: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80&w=400', // OK
    price: 249.99,
    originalPrice: 329.99,
    currency: 'PLN',
    rating: 4.9,
    reviews: 620,
    level: 'początkujący',
    duration: 'ok. 5-7 godzin materiału',
    certificate: true,
    bestSeller: true,
    description: 'Chcesz rzucić etat i pracować na własny rachunek? Ten kurs to Twój niezbędnik! Krok po kroku przeprowadzimy Cię przez proces startu na freelansie: od znalezienia swojej niszy i budowy portfolio (nawet bez doświadczenia!), przez skuteczne zdobywanie klientów (na Upwork, Fiverr i poza nimi), ustalanie cen, aż po zarządzanie finansami i formalności.',
    instructor: 'Doświadczony Freelancer & Mentor Biznesu',
    affiliateUrl: '#',
    plan: [
      'Czy freelancing jest dla Ciebie? Plusy i minusy.',
      'Wybór niszy i specjalizacji - co oferować?',
      'Budowanie portfolio od zera - jak się zaprezentować?',
      'Skuteczne działanie na platformach dla freelancerów (Upwork, Fiverr).',
      'Zdobywanie klientów poza platformami (networking, social media).',
      'Wycena pracy i ustalanie stawek.',
      'Komunikacja z klientem i zarządzanie projektami.',
      'Podstawy formalności prawnych i podatkowych freelancera w PL.',
      'Zarządzanie finansami i budowanie stabilności.',
      'Rozwój kariery freelancera i skalowanie działalności.'
    ],
    forWho: [
      'Osoby marzące o pracy na własny rachunek i niezależności.',
      'Pracownicy etatowi szukający dodatkowych zleceń lub planujący przejście na swoje.',
      'Studenci i absolwenci chcący zdobyć pierwsze doświadczenia zawodowe.',
      'Specjaliści z różnych dziedzin (graficy, copywriterzy, programiści, tłumacze, wirtualne asystentki itp.).'
    ],
    whatYouGet: [
      'Kompletny plan działania na start kariery freelancera.',
      'Strategie budowania portfolio, które przyciąga klientów.',
      'Praktyczne metody zdobywania zleceń na platformach i poza nimi.',
      'Wiedzę o wycenie usług i negocjacji stawek.',
      'Podstawy zarządzania projektami i komunikacji z klientem.',
      'Zrozumienie kluczowych aspektów prawnych i finansowych freelancingu.',
      'Pewność siebie i narzędzia do zbudowania stabilnej kariery online.'
    ],
    faq: [
      { q: 'Czy muszę mieć już doświadczenie w jakiejś dziedzinie?', a: 'Kurs pokazuje, jak wykorzystać posiadane umiejętności lub jak zdobyć pierwsze doświadczenie i zbudować portfolio od zera.' },
      { q: 'Czy kurs gwarantuje zdobycie klientów?', a: 'Kurs dostarcza strategii i narzędzi, ale sukces zależy od Twojego zaangażowania, jakości pracy i systematyczności w działaniu.' }
    ]
  },
  {
    id: 'copywriting-dla-poczatkujacych',
    title: 'Copywriting dla Początkujących: Pisz Teksty, Które Sprzedają i Angażują',
    category: 'Marketing',
    tags: ['copywriting', 'pisanie tekstów', 'marketing treści', 'content marketing', 'seo copywriting', 'oferty handlowe', 'strony internetowe', 'social media', 'email marketing', 'perswazja', 'pisanie reklam'],
    imageUrl: 'https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?auto=format&fit=crop&q=80&w=400', // OK
    price: 199.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 710,
    level: 'początkujący',
    duration: 'ok. 4-5 godzin materiału + ćwiczenia',
    certificate: true,
    bestSeller: true,
    description: 'Naucz się pisać teksty, które naprawdę działają! Ten kurs copywritingu dla początkujących pokaże Ci, jak tworzyć chwytliwe nagłówki, angażujące opisy produktów, przekonujące treści na strony WWW, posty na social media i skuteczne e-maile. Poznaj zasady perswazji, storytellingu i SEO copywritingu, aby Twoje słowa przynosiły rezultaty.',
    instructor: 'Copywriter z Doświadczeniem Agencyjnym',
    affiliateUrl: '#',
    plan: [
      'Czym jest copywriting i dlaczego jest kluczowy?',
      'Poznanie grupy docelowej i jej potrzeb.',
      'Anatomia tekstu sprzedażowego (nagłówek, oferta, CTA).',
      'Techniki pisania perswazyjnych nagłówków.',
      'Storytelling w copywritingu.',
      'Pisanie skutecznych treści na strony WWW.',
      'Copywriting dla social media.',
      'Tworzenie angażujących treści e-mail marketingowych.',
      'Podstawy SEO copywritingu.',
      'Najczęstsze błędy i ćwiczenia praktyczne.'
    ],
    forWho: [
      'Marketerzy i specjaliści ds. komunikacji.',
      'Właściciele firm i przedsiębiorcy.',
      'Blogerzy i twórcy treści online.',
      'Osoby chcące rozpocząć karierę jako copywriter.',
      'Każdy, kto chce poprawić swoje umiejętności pisarskie w kontekście biznesowym.'
    ],
    whatYouGet: [
      'Solidne podstawy warsztatu copywriterskiego.',
      'Umiejętność pisania tekstów dopasowanych do różnych kanałów (WWW, social media, email).',
      'Znajomość technik perswazji i storytellingu.',
      'Praktyczne wskazówki dotyczące tworzenia nagłówków i CTA.',
      'Podstawy SEO copywritingu.',
      'Większą pewność siebie w tworzeniu skutecznych treści marketingowych.'
    ],
    faq: [
      { q: 'Czy muszę mieć "lekkie pióro"?', a: 'Nie, copywriting to rzemiosło, którego można się nauczyć. Kurs skupia się na technikach i strukturach, a nie wrodzonym talencie.' },
      { q: 'Czy kurs obejmuje pisanie długich form (np. e-booków)?', a: 'Kurs koncentruje się na krótszych formach typowych dla marketingu online, ale zasady perswazji są uniwersalne.' }
    ]
  },
  {
    id: 'canva-projektowanie-graficzne',
    title: 'Canva: Projektowanie Graficzne dla Każdego (Bez Doświadczenia!)',
    category: 'Grafika',
    tags: ['canva', 'projektowanie graficzne', 'grafika', 'social media', 'prezentacje', 'narzędzia graficzne', 'marketing wizualny', 'design', 'bez doświadczenia', 'darmowe narzędzia'],
    imageUrl: 'https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?auto=format&fit=crop&q=80&w=400', // OK
    price: 149.99,
    originalPrice: 199.99,
    currency: 'PLN',
    rating: 4.9,
    reviews: 850,
    level: 'początkujący',
    duration: 'ok. 3-4 godziny materiału + projekty',
    certificate: true,
    bestSeller: true,
    description: 'Zostań grafikiem bez studiów! Opanuj Canvę - darmowe i intuicyjne narzędzie online - i twórz profesjonalne grafiki na social media, efektowne prezentacje, ulotki, CV, a nawet proste animacje. Kurs od podstaw pokaże Ci wszystkie kluczowe funkcje, triki i zasady projektowania, które pozwolą Ci tworzyć piękne i skuteczne materiały wizualne.',
    instructor: 'Canva Certified Creative & Trener Marketingu',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do Canvy (interfejs, szablony).',
      'Praca z tekstem, fontami i kolorami.',
      'Wykorzystanie zdjęć, elementów graficznych i ikon.',
      'Projektowanie grafik na social media (formaty, dobre praktyki).',
      'Tworzenie efektownych prezentacji.',
      'Projektowanie materiałów drukowanych (ulotki, plakaty).',
      'Przegląd funkcji premium (Canva Pro) i narzędzi AI.',
      'Tworzenie prostych animacji i wideo.',
      'Zasady projektowania i spójność wizualna.',
      'Praktyczne projekty do portfolio.'
    ],
    forWho: [
      'Marketerzy i specjaliści social media.',
      'Właściciele małych firm i freelancerzy.',
      'Blogerzy i twórcy treści.',
      'Pracownicy biurowi tworzący prezentacje i dokumenty.',
      'Nauczyciele i studenci.',
      'Każdy, kto chce tworzyć ładne grafiki bez nauki skomplikowanych programów.'
    ],
    whatYouGet: [
      'Biegłość w obsłudze Canvy od podstaw po bardziej zaawansowane funkcje.',
      'Umiejętność tworzenia profesjonalnie wyglądających grafik na różne potrzeby.',
      'Znajomość podstawowych zasad projektowania graficznego.',
      'Praktyczne szablony i triki przyspieszające pracę.',
      'Możliwość tworzenia spójnych wizualnie materiałów dla swojej marki lub firmy.',
      'Portfolio zrealizowanych projektów graficznych.'
    ],
    faq: [
      { q: 'Czy potrzebuję płatnej wersji Canva Pro?', a: 'Nie, większość kursu można zrealizować na darmowym koncie Canva. Omawiamy też funkcje Pro, ale nie są one niezbędne.' },
      { q: 'Czy muszę mieć zmysł artystyczny?', a: 'Nie, Canva i ten kurs dostarczają narzędzi i zasad, które pomogą Ci tworzyć estetyczne projekty nawet bez wrodzonych talentów.' }
    ]
  },
  {
    id: 'zarzadzanie-projektami-dla-laikow',
    title: 'Zarządzanie Projektami dla Każdego: Planuj i Realizuj Skutecznie',
    category: 'Zarządzanie',
    tags: ['zarządzanie projektami', 'planowanie', 'organizacja pracy', 'zadania', 'cele', 'produktywność', 'zespół', 'narzędzia do zarządzania projektami', 'bez żargonu', 'praktyczne metody'],
    imageUrl: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=400', // OK
    price: 169.99,
    currency: 'PLN',
    rating: 4.7,
    reviews: 410,
    level: 'początkujący',
    duration: 'ok. 3-4 godziny materiału',
    certificate: true,
    bestSeller: false,
    description: 'Masz projekt do zrealizowania (w pracy lub prywatnie) i nie wiesz, od czego zacząć? Ten kurs pokaże Ci proste i praktyczne metody planowania zadań, ustalania priorytetów, śledzenia postępów i efektywnej organizacji pracy – bez skomplikowanego żargonu i metodyk. Naucz się dowozić projekty na czas i bez stresu!',
    instructor: 'Praktyk Zarządzania Projektami',
    affiliateUrl: '#',
    plan: [
      'Co to jest projekt i dlaczego warto nim zarządzać?',
      'Definiowanie celu i zakresu projektu.',
      'Dzielenie projektu na mniejsze zadania (WBS).',
      'Szacowanie czasu i ustalanie realistycznych terminów.',
      'Proste metody priorytetyzacji zadań.',
      'Tworzenie harmonogramu (np. podstawy wykresu Gantta).',
      'Organizacja pracy własnej i zespołu (jeśli dotyczy).',
      'Monitorowanie postępów i reagowanie na problemy.',
      'Przegląd prostych narzędzi do zarządzania (Trello, Asana).',
      'Zamykanie projektu i wnioski na przyszłość.'
    ],
    forWho: [
      'Osoby, które realizują projekty w pracy, ale nie są Project Managerami.',
      'Studenci pracujący nad projektami grupowymi.',
      'Freelancerzy zarządzający własnymi zleceniami.',
      'Każdy, kto chce lepiej zorganizować swoje działania i skuteczniej realizować cele.'
    ],
    whatYouGet: [
      'Proste i uniwersalne metody planowania i organizacji projektów.',
      'Umiejętność dzielenia dużych zadań na mniejsze, łatwiejsze do zarządzania.',
      'Sposoby na realistyczne szacowanie czasu i ustalanie terminów.',
      'Praktyczne techniki priorytetyzacji.',
      'Wiedzę o podstawowych narzędziach wspierających zarządzanie projektami.',
      'Większą kontrolę nad realizacją swoich celów i projektów.'
    ],
    faq: [
      { q: 'Czy kurs omawia Scrum lub Agile?', a: 'Nie, ten kurs skupia się na uniwersalnych, prostych technikach planowania i organizacji, zrozumiałych bez znajomości specyficznych metodyk jak Scrum.' },
      { q: 'Czy potrzebuję specjalnego oprogramowania?', a: 'Kurs omawia koncepcje, które można zastosować nawet z kartką i długopisem. Pokazujemy też przykłady w popularnych, darmowych narzędziach jak Trello.' }
    ]
  },
  {
    id: 'strona-www-bez-kodu',
    title: 'Stwórz Profesjonalną Stronę WWW Bez Kodu (Webflow / WordPress + Elementor)',
    category: 'Narzędzia No-Code',
    tags: ['strona internetowa', 'tworzenie stron', 'bez kodu', 'no-code', 'low-code', 'webflow', 'wordpress', 'elementor', 'projektowanie stron', 'web design', 'strona firmowa', 'portfolio online', 'blog'],
    imageUrl: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?auto=format&fit=crop&q=80&w=400', // Nowy URL - Laptop z edytorem stron
    price: 279.99,
    originalPrice: 359.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 590,
    level: 'początkujący',
    duration: 'ok. 6-8 godzin materiału i projekt',
    certificate: true,
    bestSeller: true,
    description: 'Twoja własna strona internetowa w zasięgu ręki – bez pisania kodu! Ten kurs nauczy Cię tworzyć piękne, nowoczesne i responsywne strony WWW, blogi lub portfolio za pomocą popularnych narzędzi wizualnych: Webflow lub WordPress z wtyczką Elementor. Krok po kroku, od projektu po publikację w sieci.',
    instructor: 'Web Designer & Ekspert No-Code',
    affiliateUrl: '#',
    plan: [
      'Wprowadzenie do No-Code/Low-Code i wybór narzędzia.',
      'Planowanie struktury i treści strony.',
      'Podstawy Webflow (interfejs, budowanie wizualne).',
      'Praca z Webflow (layout, stylowanie, CMS).',
      'Podstawy WordPressa i Elementora.',
      'Tworzenie stron w Elementorze (widgety, szablony).',
      'Projektowanie responsywne (mobile-first).',
      'Dodawanie formularzy i interakcji.',
      'Podstawy SEO dla strony no-code.',
      'Hosting, domena i publikacja strony.',
      'Praktyczny projekt strony WWW.'
    ],
    forWho: [
      'Przedsiębiorcy i właściciele małych firm.',
      'Freelancerzy i twórcy chcący stworzyć portfolio online.',
      'Marketerzy potrzebujący szybko tworzyć landing page.',
      'Blogerzy chcący założyć profesjonalnie wyglądający blog.',
      'Każdy, kto chce mieć własną stronę WWW bez nauki programowania.'
    ],
    whatYouGet: [
      'Umiejętność tworzenia funkcjonalnych i estetycznych stron WWW bez kodowania.',
      'Praktyczną znajomość Webflow lub WordPress z Elementorem.',
      'Wiedzę o projektowaniu responsywnym.',
      'Podstawy optymalizacji SEO dla stworzonej strony.',
      'Umiejętność opublikowania strony w internecie.',
      'Gotową stronę internetową do swojego portfolio lub biznesu.'
    ],
    faq: [
      { q: 'Które narzędzie wybrać: Webflow czy WordPress+Elementor?', a: 'Kurs omawia oba podejścia, wskazując ich wady i zalety, abyś mógł wybrać najlepsze dla siebie. Możesz skupić się na jednym lub poznać oba.' },
      { q: 'Czy potrzebuję płatnych narzędzi?', a: 'WordPress i Elementor (wersja darmowa) są darmowe. Webflow ma darmowy plan z ograniczeniami. Hosting i domena zawsze wiążą się z kosztem, niezależnie od narzędzia.' }
    ]
  },
  {
    id: 'tiktok-marketing',
    title: 'TikTok Marketing: Zbuduj Zasięgi i Markę na Najpopularniejszej Platformie',
    category: 'Media Społecznościowe',
    tags: ['tiktok', 'tiktok marketing', 'social media marketing', 'marketing wideo', 'krótkie formy wideo', 'budowanie społeczności', 'viral marketing', 'influencer marketing', 'reklama na tiktoku'],
    imageUrl: 'https://images.unsplash.com/photo-1611162617358-49d434f43e42?auto=format&fit=crop&q=80&w=400', // Nowy URL - Telefon z ikoną podobną do TikToka
    price: 209.99,
    currency: 'PLN',
    rating: 4.7,
    reviews: 350,
    level: 'początkujący',
    duration: 'ok. 4-5 godzin materiału',
    certificate: true,
    bestSeller: false,
    description: 'Wykorzystaj potencjał TikToka dla swojej marki lub firmy! Ten kurs pokaże Ci, jak działa algorytm tej platformy, jak tworzyć angażujące i potencjalnie viralowe wideo, wykorzystywać trendy, budować lojalną społeczność i efektywnie promować swoje produkty lub usługi. Od podstaw po zaawansowane strategie.',
    instructor: 'Ekspert Marketingu na TikToku',
    affiliateUrl: '#',
    plan: [
      'Fenomen TikToka i działanie algorytmu.',
      'Tworzenie i optymalizacja profilu.',
      'Rodzaje treści, które działają na TikToku.',
      'Podstawy nagrywania i montażu w aplikacji TikTok.',
      'Wykorzystanie dźwięków, efektów i hashtagów.',
      'Budowanie społeczności i interakcja.',
      'Strategie marketingowe dla firm.',
      'Podstawy reklamy płatnej (TikTok Ads).',
      'Analiza statystyk i mierzenie efektywności.',
      'Współpraca z influencerami na TikToku.'
    ],
    forWho: [
      'Marketerzy i specjaliści social media.',
      'Właściciele firm (szczególnie B2C).',
      'Twórcy treści i influencerzy.',
      'Osoby budujące markę osobistą.',
      'Każdy, kto chce zrozumieć i wykorzystać marketingowo TikToka.'
    ],
    whatYouGet: [
      'Zrozumienie mechanizmów działania TikToka.',
      'Umiejętność tworzenia angażujących treści wideo dopasowanych do platformy.',
      'Strategie budowania zasięgów i społeczności.',
      'Praktyczne wskazówki dotyczące wykorzystania trendów i hashtagów.',
      'Podstawy prowadzenia kampanii reklamowych na TikToku.',
      'Wiedzę o analizie wyników i optymalizacji działań.'
    ],
    faq: [
      { q: 'Czy muszę pokazywać twarz na TikToku?', a: 'Niekoniecznie, kurs omawia różne formaty treści, również te niewymagające pokazywania twarzy.' },
      { q: 'Czy TikTok jest tylko dla młodzieży?', a: 'Nie, platforma ma coraz szersze grono odbiorców w różnym wieku, w tym wielu dorosłych.' }
    ]
  },
  {
    id: 'youtube-dla-poczatkujacych',
    title: 'YouTube dla Początkujących: Załóż Kanał, Nagrywaj i Zarabiaj',
    category: 'Produkcja Wideo/Audio',
    tags: ['youtube', 'tworzenie wideo', 'vlog', 'content marketing', 'marketing wideo', 'edycja wideo', 'seo youtube', 'monetyzacja', 'budowanie kanału', 'influencer'],
    imageUrl: 'https://images.unsplash.com/photo-1541560052-77ec1bbc09f7?auto=format&fit=crop&q=80&w=400', // OK
    price: 229.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 680,
    level: 'początkujący',
    duration: 'ok. 6-8 godzin materiału',
    certificate: true,
    bestSeller: true,
    description: 'Marzysz o własnym kanale na YouTube? Ten kurs poprowadzi Cię krok po kroku! Od znalezienia pomysłu i niszy, przez założenie i konfigurację kanału, podstawy nagrywania i prostego montażu (nawet telefonem!), po zrozumienie algorytmu, optymalizację filmów (SEO) dla większych zasięgów i poznanie różnych strategii monetyzacji.',
    instructor: 'Doświadczony YouTuber & Twórca Wideo',
    affiliateUrl: '#',
    plan: [
      'Potencjał YouTube i wybór niszy.',
      'Zakładanie i profesjonalna konfiguracja kanału.',
      'Podstawy sprzętu do nagrywania.',
      'Techniki nagrywania angażujących filmów.',
      'Prosty montaż wideo (darmowe narzędzia).',
      'Działanie algorytmu YouTube.',
      'Optymalizacja filmów pod SEO (tytuł, opis, tagi, miniatura).',
      'Budowanie społeczności i interakcja.',
      'Strategie monetyzacji kanału.',
      'Analiza statystyk (YouTube Analytics).',
      'Aspekty prawne (prawa autorskie).'
    ],
    forWho: [
      'Osoby chcące założyć własny kanał na YouTube.',
      'Twórcy treści, blogerzy, eksperci chcący dotrzeć do nowej publiczności.',
      'Firmy chcące wykorzystać YouTube w swojej strategii marketingowej.',
      'Każdy, kto chce nauczyć się tworzyć i publikować wideo online.'
    ],
    whatYouGet: [
      'Kompletny przewodnik po starcie i rozwoju kanału na YouTube.',
      'Praktyczne umiejętności nagrywania i podstawowego montażu wideo.',
      'Wiedzę o działaniu algorytmu i optymalizacji SEO dla filmów.',
      'Strategie budowania zaangażowanej społeczności.',
      'Przegląd możliwości zarabiania na YouTube.',
      'Umiejętność analizy statystyk i rozwoju kanału.'
    ],
    faq: [
      { q: 'Czy potrzebuję drogiego sprzętu?', a: 'Nie, kurs pokazuje jak zacząć nawet z użyciem smartfona i podstawowego mikrofonu.' },
      { q: 'Czy nauczę się skomplikowanego montażu?', a: 'Kurs skupia się na prostym, szybkim montażu w darmowych lub łatwo dostępnych narzędziach, wystarczającym na potrzeby YouTube.' }
    ]
  },
  {
    id: 'podcast-od-zera',
    title: 'Podcast od Zera: Nagraj, Zmontuj i Opublikuj Swój Pierwszy Odcinek',
    category: 'Produkcja Wideo/Audio',
    tags: ['podcast', 'podcasty', 'nagrywanie audio', 'montaż audio', 'audacity', 'produkcja audio', 'dystrybucja podcastu', 'spotify', 'apple podcasts', 'tworzenie treści'],
    imageUrl: 'https://images.unsplash.com/photo-1590602847818-b80671094e9a?auto=format&fit=crop&q=80&w=400', // OK
    price: 189.99,
    originalPrice: 239.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 380,
    level: 'początkujący',
    duration: 'ok. 4-6 godzin materiału',
    certificate: true,
    bestSeller: false,
    description: 'Marzysz o własnym podcaście? Ten kurs pokaże Ci, jak zacząć! Krok po kroku: od planowania i wyboru sprzętu (nawet budżetowego), przez techniki nagrywania czystego dźwięku, podstawy montażu w darmowym programie Audacity, aż po publikację na popularnych platformach (Spotify, Apple Podcasts) i strategie promocji.',
    instructor: 'Doświadczony Podcaster i Dziennikarz Radiowy',
    affiliateUrl: '#',
    plan: [
      'Planowanie podcastu (tematyka, format).',
      'Wybór sprzętu dla początkujących (mikrofon, akcesoria).',
      'Techniki nagrywania dobrej jakości dźwięku.',
      'Wprowadzenie do edycji audio w Audacity.',
      'Podstawy montażu (cięcie, szumy, intro/outro, muzyka).',
      'Mastering audio dla profesjonalnego brzmienia.',
      'Hosting i publikacja na platformach (Spotify, Apple Podcasts).',
      'Tworzenie okładki i opisów odcinków.',
      'Podstawowe strategie promocji podcastu.'
    ],
    forWho: [
      'Osoby marzące o stworzeniu własnego podcastu.',
      'Twórcy treści chcący poszerzyć swoje kanały komunikacji.',
      'Eksperci i pasjonaci chcący dzielić się wiedzą w formie audio.',
      'Firmy szukające nowych form content marketingu.'
    ],
    whatYouGet: [
      'Kompleksową wiedzę potrzebną do uruchomienia własnego podcastu.',
      'Praktyczne wskazówki dotyczące wyboru sprzętu i technik nagrywania.',
      'Umiejętność podstawowego montażu i masteringu audio w Audacity.',
      'Wiedzę o procesie publikacji podcastu na najważniejszych platformach.',
      'Podstawowe strategie promocji i budowania słuchalności.'
    ],
    faq: [
      { q: 'Czy potrzebuję drogiego sprzętu?', a: 'Nie, kurs pokazuje, jak zacząć nawet z budżetowym mikrofonem USB lub rejestratorem.' },
      { q: 'Czy muszę znać się na technice audio?', a: 'Nie, kurs tłumaczy wszystko od podstaw w przystępny sposób.' }
    ]
  },
  {
    id: 'mindfulness-redukcja-stresu',
    title: 'Mindfulness i Redukcja Stresu dla Zabieganych: Odzyskaj Spokój',
    category: 'Rozwój osobisty',
    tags: ['mindfulness', 'uważność', 'medytacja', 'redukcja stresu', 'relaksacja', 'zdrowie psychiczne', 'dobrostan', 'inteligencja emocjonalna', 'koncentracja', 'spokój wewnętrzny'],
    imageUrl: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&q=80&w=400', // OK
    price: 159.99,
    currency: 'PLN',
    rating: 4.9,
    reviews: 950,
    level: 'początkujący',
    duration: 'ok. 2-3 godziny materiału + praktyki',
    certificate: true,
    bestSeller: true,
    description: 'Czujesz ciągłe napięcie i przebodźcowanie? Odkryj moc mindfulness! Ten kurs wprowadzi Cię w świat uważności i prostych technik medytacyjnych, które pomogą Ci zredukować stres, poprawić koncentrację, lepiej radzić sobie z emocjami i odzyskać wewnętrzny spokój – nawet jeśli masz tylko kilka minut dziennie.',
    instructor: 'Certyfikowany Nauczyciel Mindfulness (MBSR)',
    affiliateUrl: '#',
    plan: [
      'Czym jest mindfulness (uważność) i jak działa na mózg?',
      'Podstawowe ćwiczenia oddechowe.',
      'Uważność ciała (skanowanie ciała).',
      'Radzenie sobie z natłokiem myśli.',
      'Praktykowanie uważności w codziennych czynnościach.',
      'Uważność a emocje - akceptacja i regulacja.',
      'Krótkie praktyki mindfulness na co dzień.',
      'Budowanie nawyku regularnej praktyki.',
      'Korzyści z mindfulness dla zdrowia.'
    ],
    forWho: [
      'Osoby doświadczające chronicznego stresu i napięcia.',
      'Ci, którzy mają problemy z koncentracją i rozproszeniem uwagi.',
      'Osoby chcące lepiej radzić sobie z trudnymi emocjami.',
      'Pracownicy korporacji, przedsiębiorcy, studenci – wszyscy żyjący w szybkim tempie.',
      'Każdy, kto szuka praktycznych narzędzi do poprawy samopoczucia i jakości życia.'
    ],
    whatYouGet: [
      'Zrozumienie naukowych podstaw mindfulness i jego korzyści.',
      'Zestaw prostych, praktycznych ćwiczeń uważności i medytacji.',
      'Umiejętność radzenia sobie ze stresem i natłokiem myśli.',
      'Poprawę koncentracji i zdolności do bycia "tu i teraz".',
      'Lepsze rozumienie i akceptację własnych emocji.',
      'Narzędzia do budowania wewnętrznego spokoju i odporności psychicznej.'
    ],
    faq: [
      { q: 'Czy muszę siedzieć w pozycji lotosu?', a: 'Absolutnie nie! Kurs uczy praktyk, które można wykonywać siedząc na krześle, leżąc, a nawet podczas chodzenia.' },
      { q: 'Czy to jest związane z religią?', a: 'Mindfulness, choć ma korzenie w tradycjach wschodnich, jest tutaj prezentowane jako świecka technika treningu umysłu, poparta badaniami naukowymi.' }
    ]
  },
  {
    id: 'asertywnosc-bez-agresji',
    title: 'Asertywność bez Agresji: Stawiaj Granice, Mów "Nie", Bądź Sobą',
    category: 'Umiejętności miękkie',
    tags: ['asertywność', 'komunikacja', 'stawianie granic', 'odmawianie', 'pewność siebie', 'relacje interpersonalne', 'rozwój osobisty', 'inteligencja emocjonalna', 'szacunek do siebie'],
    imageUrl: 'https://images.unsplash.com/photo-1556741533-4020f6010a08?auto=format&fit=crop&q=80&w=400', // OK
    price: 179.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 530,
    level: 'początkujący',
    duration: 'ok. 3-4 godziny materiału i ćwiczeń',
    certificate: true,
    bestSeller: false,
    description: 'Masz problem z odmawianiem? Bierzesz na siebie za dużo? Czujesz, że inni Cię wykorzystują? Ten kurs nauczy Cię asertywności! Dowiesz się, jak wyrażać swoje potrzeby i opinie, stawiać zdrowe granice i mówić "nie" bez poczucia winy – w sposób stanowczy, ale pełen szacunku dla siebie i innych. Zbuduj pewność siebie w relacjach!',
    instructor: 'Psycholog i Trener Umiejętności Społecznych',
    affiliateUrl: '#',
    plan: [
      'Czym jest asertywność (a czym nie jest)?',
      'Rozpoznawanie swoich praw i potrzeb.',
      'Technika komunikatu "Ja".',
      'Sztuka asertywnego odmawiania.',
      'Stawianie granic w relacjach.',
      'Wyrażanie i przyjmowanie krytyki.',
      'Radzenie sobie z manipulacją.',
      'Asertywność w trudnych rozmowach.',
      'Budowanie asertywnej postawy.',
      'Ćwiczenia praktyczne i scenariusze.'
    ],
    forWho: [
      'Osoby, które mają trudności z mówieniem "nie".',
      'Ci, którzy czują się wykorzystywani lub nie potrafią zadbać o swoje potrzeby.',
      'Osoby chcące poprawić swoje relacje w pracy i życiu prywatnym.',
      'Pracownicy, którzy chcą lepiej komunikować się z przełożonymi i współpracownikami.',
      'Każdy, kto chce zbudować większą pewność siebie i poczucie własnej wartości.'
    ],
    whatYouGet: [
      'Zrozumienie, czym jest zdrowa asertywność.',
      'Praktyczne techniki wyrażania swoich potrzeb i opinii.',
      'Umiejętność skutecznego odmawiania i stawiania granic.',
      'Sposoby radzenia sobie z krytyką i manipulacją.',
      'Większą pewność siebie w komunikacji interpersonalnej.',
      'Narzędzia do budowania bardziej satysfakcjonujących relacji.'
    ],
    faq: [
      { q: 'Czy asertywność oznacza bycie niemiłym?', a: 'Absolutnie nie! Prawdziwa asertywność polega na wyrażaniu siebie z szacunkiem, zarówno dla własnych potrzeb, jak i dla drugiej osoby.' },
      { q: 'Czy można się nauczyć asertywności, jeśli jestem nieśmiały?', a: 'Tak, asertywność to umiejętność, którą można wyćwiczyć krok po kroku, niezależnie od temperamentu.' }
    ]
  },
  {
    id: 'superskuteczna-nauka',
    title: 'Superskuteczna Nauka: Jak Uczyć Się Szybciej i Zapamiętywać Więcej',
    category: 'Rozwój osobisty',
    tags: ['nauka', 'uczenie się', 'efektywna nauka', 'pamięć', 'zapamiętywanie', 'koncentracja', 'notatki', 'szybkie czytanie', 'mnemotechniki', 'organizacja nauki', 'studia', 'rozwój umysłu'],
    imageUrl: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?auto=format&fit=crop&q=80&w=400', // OK
    price: 189.99,
    currency: 'PLN',
    rating: 4.7,
    reviews: 490,
    level: 'początkujący',
    duration: 'ok. 4-5 godzin materiału i technik',
    certificate: true,
    bestSeller: false,
    description: 'Zmień swoje podejście do nauki! Ten kurs pokaże Ci sprawdzone metody, jak uczyć się efektywniej, szybciej przyswajać wiedzę i trwale ją zapamiętywać. Poznasz techniki skutecznego notowania (np. mapy myśli), podstawy szybkiego czytania, mnemotechniki ułatwiające zapamiętywanie oraz sposoby na lepszą koncentrację i organizację procesu nauki.',
    instructor: 'Trener Efektywnej Nauki',
    affiliateUrl: '#',
    plan: [
      'Jak działa mózg podczas nauki?',
      'Wyznaczanie celów nauki i planowanie.',
      'Techniki aktywnego uczenia się.',
      'Skuteczne notowanie (Metoda Cornella, mapy myśli).',
      'Podstawy szybkiego czytania ze zrozumieniem.',
      'Mnemotechniki (haki pamięciowe, pałac pamięci).',
      'Rola powtórek i system Spaced Repetition.',
      'Poprawa koncentracji i walka z rozpraszaczami.',
      'Wpływ snu, diety i ruchu na naukę.',
      'Organizacja materiałów i środowiska do nauki.'
    ],
    forWho: [
      'Studenci i uczniowie chcący poprawić swoje wyniki w nauce.',
      'Profesjonaliści uczący się nowych umiejętności lub języków.',
      'Osoby przygotowujące się do egzaminów i certyfikatów.',
      'Każdy, kto chce szybciej i skuteczniej przyswajać wiedzę.'
    ],
    whatYouGet: [
      'Zestaw praktycznych technik efektywnej nauki.',
      'Umiejętność tworzenia notatek, które ułatwiają zapamiętywanie.',
      'Podstawy szybszego czytania i lepszego rozumienia tekstów.',
      'Metody mnemotechniczne do zapamiętywania faktów, list, słówek.',
      'Sposoby na zwiększenie koncentracji i lepszą organizację nauki.',
      'Większą efektywność i mniej stresu związanego z nauką.'
    ],
    faq: [
      { q: 'Czy nauczę się czytać superszybko?', a: 'Kurs uczy podstaw i technik zwiększania tempa czytania ze zrozumieniem, ale osiągnięcie bardzo wysokiej prędkości wymaga dużo praktyki.' },
      { q: 'Czy te metody działają dla każdego?', a: 'Tak, przedstawione techniki bazują na tym, jak działa ludzki mózg i pamięć, są uniwersalne, choć każdy może znaleźć swoje ulubione.' }
    ]
  },
  {
    id: 'grafika-dla-laikow-gimp',
    title: 'Grafika Komputerowa dla Laików (GIMP / Photopea - Darmowe Narzędzia)',
    category: 'Grafika',
    tags: ['grafika komputerowa', 'gimp', 'photopea', 'edycja zdjęć', 'obróbka zdjęć', 'darmowe oprogramowanie', 'alternatywa dla photoshopa', 'grafika dla początkujących', 'retusz', 'tworzenie grafik'],
    imageUrl: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&q=80&w=400', // Nowy URL - bardziej ogólny design/grafika
    price: 159.99,
    currency: 'PLN',
    rating: 4.6,
    reviews: 320,
    level: 'początkujący',
    duration: 'ok. 5-6 godzin materiału',
    certificate: true,
    bestSeller: false,
    description: 'Chcesz edytować zdjęcia i tworzyć proste grafiki, ale Photoshop jest za drogi lub za trudny? Ten kurs nauczy Cię obsługi GIMPa i Photopea – potężnych, darmowych alternatyw! Opanujesz podstawy: pracę na warstwach, zaznaczanie, retusz zdjęć, usuwanie tła, tworzenie banerów i grafik na social media.',
    instructor: 'Grafik Komputerowy & Entuzjasta Open Source',
    affiliateUrl: '#',
    plan: [
      'Porównanie GIMP vs Photopea i interfejsy.',
      'Podstawowe narzędzia (pędzel, gumka, wypełnienie).',
      'Praca na warstwach - fundament edycji.',
      'Narzędzia zaznaczania i wycinanie obiektów.',
      'Podstawowa edycja zdjęć (jasność, kontrast, kolory).',
      'Prosty retusz portretu.',
      'Techniki usuwania tła.',
      'Praca z tekstem w grafice.',
      'Tworzenie prostych grafik (banery, posty).',
      'Eksportowanie grafiki w różnych formatach.'
    ],
    forWho: [
      'Osoby szukające darmowej alternatywy dla Adobe Photoshop.',
      'Blogerzy, marketerzy, właściciele małych firm potrzebujący tworzyć grafiki.',
      'Amatorzy fotografii chcący nauczyć się podstawowej obróbki.',
      'Każdy, kto chce nauczyć się podstaw edycji grafiki rastrowej.'
    ],
    whatYouGet: [
      'Umiejętność obsługi GIMPa lub Photopea na poziomie podstawowym.',
      'Zdolność do prostej edycji i retuszu zdjęć.',
      'Techniki precyzyjnego zaznaczania i usuwania tła.',
      'Umiejętność tworzenia prostych grafik z tekstem i obrazami.',
      'Wiedzę o podstawowych formatach graficznych i eksporcie.'
    ],
    faq: [
      { q: 'Czy GIMP/Photopea są trudne?', a: 'Mają inny interfejs niż Photoshop, ale kurs prowadzi krok po kroku przez najważniejsze funkcje.' },
      { q: 'Czy mogę używać tylko jednego programu?', a: 'Tak, kurs pokazuje oba, ale możesz skupić się na tym, który bardziej Ci odpowiada (GIMP - desktop, Photopea - online).' }
    ]
  },
  {
    id: 'ecommerce-start',
    title: 'E-commerce Start: Jak Założyć i Wypromować Swój Pierwszy Sklep Internetowy?',
    category: 'E-commerce',
    tags: ['ecommerce', 'sklep internetowy', 'handel online', 'sprzedaż internetowa', 'biznes online', 'shoper', 'shopify', 'woocommerce', 'marketing dla e-commerce', 'płatności online', 'logistyka'],
    imageUrl: 'https://images.unsplash.com/photo-1556740738-b6a63e27c4df?auto=format&fit=crop&q=80&w=400', // OK
    price: 299.99,
    currency: 'PLN',
    rating: 4.7,
    reviews: 510,
    level: 'początkujący',
    duration: 'ok. 7-9 godzin materiału',
    certificate: true,
    bestSeller: false,
    description: 'Marzysz o własnym sklepie online? Ten kurs to Twój przewodnik od A do Z! Pomożemy Ci wybrać odpowiednią platformę e-commerce (SaaS jak Shoper/Shopify vs WooCommerce), skonfigurować sklep, dodać produkty, ustawić płatności i wysyłkę. Poznasz też kluczowe strategie marketingowe, które pomogą Ci zdobyć pierwszych klientów.',
    instructor: 'Praktyk E-commerce & Konsultant',
    affiliateUrl: '#',
    plan: [
      'Pomysł na e-sklep i wybór niszy.',
      'Wybór platformy e-commerce (SaaS vs Open Source).',
      'Konfiguracja sklepu (domena, wygląd, ustawienia).',
      'Dodawanie produktów (opisy, zdjęcia, kategorie).',
      'Integracja płatności online.',
      'Logistyka i wysyłka (modele, opcje dostawy).',
      'Podstawy prawne w e-commerce (regulamin, RODO).',
      'Marketing dla e-commerce (SEO, Google Ads, Social Media).',
      'Podstawy analityki w e-sklepie.',
      'Obsługa klienta i budowanie lojalności.'
    ],
    forWho: [
      'Osoby chcące założyć swój pierwszy sklep internetowy.',
      'Właściciele firm stacjonarnych planujący wejście do online.',
      'Przedsiębiorcy szukający nowego kanału sprzedaży.',
      'Każdy, kto interesuje się branżą e-commerce.'
    ],
    whatYouGet: [
      'Wiedzę potrzebną do wyboru i uruchomienia sklepu internetowego.',
      'Umiejętność konfiguracji podstawowych funkcji platformy e-commerce.',
      'Praktyczne wskazówki dotyczące dodawania produktów i zarządzania nimi.',
      'Przegląd opcji płatności i wysyłki.',
      'Podstawy marketingu i analityki dla e-sklepu.',
      'Świadomość kluczowych aspektów prawnych.'
    ],
    faq: [
      { q: 'Czy potrzebuję dużego budżetu na start?', a: 'Kurs omawia różne platformy, w tym takie z niskim progiem wejścia. Koszty zależą od wybranego modelu i skali działalności.' },
      { q: 'Czy kurs uczy programowania?', a: 'Nie, skupiamy się na gotowych platformach e-commerce, które nie wymagają kodowania (lub minimalnie przy WooCommerce).' }
    ]
  },
  {
    id: 'prezentacje-biznesowe',
    title: 'Prezentacje Biznesowe, Które Zachwycają: Struktura, Slajdy i Storytelling',
    category: 'Umiejętności miękkie',
    tags: ['prezentacje biznesowe', 'wystąpienia publiczne', 'komunikacja biznesowa', 'projektowanie slajdów', 'powerpoint', 'keynote', 'google slides', 'storytelling biznesowy', 'perswazja', 'wizualizacja danych'],
    imageUrl: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&q=80&w=400', // OK
    price: 209.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 440,
    level: 'średniozaawansowany',
    duration: 'ok. 4-5 godzin materiału',
    certificate: true,
    bestSeller: false,
    description: 'Twoje prezentacje są nudne i nie przynoszą efektów? Zmień to! Ten kurs nauczy Cię, jak tworzyć i wygłaszać prezentacje biznesowe, które naprawdę przekonują. Skupimy się na budowaniu logicznej struktury, projektowaniu czytelnych i estetycznych slajdów (bez przeładowania!), wizualizacji danych oraz wykorzystaniu storytellingu, aby zaangażować słuchaczy i osiągnąć cel.',
    instructor: 'Trener Biznesu i Ekspert ds. Komunikacji',
    affiliateUrl: '#',
    plan: [
      'Określenie celu prezentacji i analiza audytorium.',
      'Budowanie logicznej struktury (wstęp, rozwinięcie, zakończenie).',
      'Zasady projektowania skutecznych slajdów.',
      'Efektywna wizualizacja danych.',
      'Wykorzystanie storytellingu w biznesie.',
      'Praktyczne porady dotyczące PowerPoint/Keynote/Google Slides.',
      'Przygotowanie do wystąpienia i Q&A.',
      'Angażowanie publiczności (online i offline).',
      'Najczęstsze błędy w prezentacjach biznesowych.'
    ],
    forWho: [
      'Managerowie i liderzy zespołów.',
      'Sprzedawcy i przedstawiciele handlowi.',
      'Analitycy i specjaliści prezentujący dane.',
      'Pracownicy działów marketingu i PR.',
      'Każdy, kto musi tworzyć i wygłaszać prezentacje w kontekście zawodowym.'
    ],
    whatYouGet: [
      'Umiejętność tworzenia klarownych i logicznych struktur prezentacji.',
      'Zasady projektowania profesjonalnych i estetycznych slajdów.',
      'Techniki skutecznej wizualizacji danych.',
      'Praktyczne metody wykorzystania storytellingu w biznesie.',
      'Większą pewność siebie podczas prezentowania.',
      'Narzędzia do angażowania słuchaczy i odpowiadania na pytania.'
    ],
    faq: [
      { q: 'Czy kurs skupia się na konkretnym programie (np. PowerPoint)?', a: 'Kurs omawia uniwersalne zasady projektowania i struktury. Przykłady mogą być pokazywane w różnych programach, ale wiedza jest przenośna.' },
      { q: 'Czy ten kurs obejmuje techniki samego występowania (mowa ciała, głos)?', a: 'Kurs skupia się głównie na treści, strukturze i slajdach. Aspekty samego występowania są poruszane, ale mniej szczegółowo niż w dedykowanym kursie o wystąpieniach publicznych.' }
    ]
  },
  {
    id: 'wordpress-dla-poczatkujacych',
    title: 'WordPress dla Początkujących: Stwórz Bloga lub Stronę Firmową Bez Programowania',
    category: 'Narzędzia No-Code',
    tags: ['wordpress', 'tworzenie stron', 'strona internetowa', 'blog', 'strona firmowa', 'cms', 'gutenberg', 'elementor', 'bez kodu', 'web design dla początkujących'],
    imageUrl: 'https://images.unsplash.com/photo-1593720219276-0b1eacd0aef4?auto=format&fit=crop&q=80&w=400', // Nowy URL - bardziej ogólny web dev/blog
    price: 189.99,
    originalPrice: 249.99,
    currency: 'PLN',
    rating: 4.7,
    reviews: 750,
    level: 'początkujący',
    duration: 'ok. 5-7 godzin materiału',
    certificate: true,
    bestSeller: true,
    description: 'Chcesz założyć własnego bloga lub stronę dla firmy, ale nie znasz się na kodowaniu? WordPress to rozwiązanie! Ten kurs krok po kroku pokaże Ci, jak zainstalować i skonfigurować WordPressa, wybrać i dostosować motyw graficzny, tworzyć treści za pomocą edytora blokowego (Gutenberg) lub popularnej wtyczki Elementor oraz zainstalować kluczowe wtyczki.',
    instructor: 'Ekspert WordPress & Web Developer',
    affiliateUrl: '#',
    plan: [
      'Czym jest WordPress i dlaczego warto go wybrać?',
      'Wybór hostingu, domeny i instalacja WP.',
      'Nawigacja po panelu administracyjnym.',
      'Wybór, instalacja i konfiguracja motywu.',
      'Tworzenie treści (wpisy vs strony, edytor Gutenberg).',
      'Wprowadzenie do Elementora (tworzenie wizualne).',
      'Personalizacja wyglądu (menu, widgety).',
      'Instalacja i konfiguracja kluczowych wtyczek (SEO, formularze).',
      'Zarządzanie użytkownikami i komentarzami.',
      'Podstawy utrzymania strony (aktualizacje, backupy).'
    ],
    forWho: [
      'Osoby chcące założyć bloga.',
      'Małe firmy i freelancerzy potrzebujący strony wizytówki.',
      'Każdy, kto chce nauczyć się zarządzać własną stroną na WordPressie.',
      'Początkujący twórcy stron internetowych.'
    ],
    whatYouGet: [
      'Umiejętność samodzielnego założenia i skonfigurowania strony na WordPressie.',
      'Biegłość w tworzeniu i edycji treści za pomocą edytora blokowego lub Elementora.',
      'Wiedzę o wyborze i dostosowywaniu motywów graficznych.',
      'Umiejętność instalacji i konfiguracji najważniejszych wtyczek.',
      'Podstawy zarządzania i utrzymania strony WordPress.'
    ],
    faq: [
      { q: 'Czy potrzebuję umiejętności technicznych?', a: 'Kurs jest przeznaczony dla początkujących, nie wymaga znajomości kodowania.' },
      { q: 'Czy WordPress jest darmowy?', a: 'Oprogramowanie WordPress jest darmowe, ale potrzebujesz płatnego hostingu i domeny, aby strona była dostępna online. Wtyczki i motywy mają wersje darmowe i płatne.' }
    ]
  },
  {
    id: 'angielski-biznesowy',
    title: 'Angielski Biznesowy dla Każdego: Kluczowe Zwroty i Komunikacja w Pracy',
    category: 'Języki',
    tags: ['angielski biznesowy', 'business english', 'angielski w pracy', 'komunikacja biznesowa', 'e-maile po angielsku', 'spotkania po angielsku', 'prezentacje po angielsku', 'język angielski', 'rozwój zawodowy'],
    imageUrl: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&q=80&w=400', // OK
    price: 179.99,
    currency: 'PLN',
    rating: 4.8,
    reviews: 810,
    level: 'średniozaawansowany',
    duration: 'ok. 6-8 godzin materiału + ćwiczenia',
    certificate: true,
    bestSeller: true,
    description: 'Podnieś swoje kompetencje językowe w pracy! Ten praktyczny kurs skupia się na najczęściej używanych zwrotach i wyrażeniach w angielskim biznesowym. Nauczysz się pisać profesjonalne e-maile, swobodnie uczestniczyć w spotkaniach i rozmowach telefonicznych oraz przygotowywać i prowadzić prezentacje po angielsku. Zwiększ swoją pewność siebie w międzynarodowym środowisku!',
    instructor: 'Lektor Angielskiego Biznesowego z Doświadczeniem Korporacyjnym',
    affiliateUrl: '#',
    plan: [
      'Kluczowe słownictwo biznesowe.',
      'Pisanie profesjonalnych e-maili.',
      'Small talk i networking.',
      'Udział w spotkaniach (wyrażanie opinii, dyskusja).',
      'Rozmowy telefoniczne i telekonferencje.',
      'Przygotowanie i prowadzenie prezentacji.',
      'Podstawy negocjacji po angielsku.',
      'Typowe błędy językowe w kontekście biznesowym.',
      'Ćwiczenia praktyczne i scenki sytuacyjne.'
    ],
    forWho: [
      'Pracownicy firm międzynarodowych.',
      'Osoby szukające pracy wymagającej znajomości angielskiego biznesowego.',
      'Managerowie i specjaliści współpracujący z zagranicznymi partnerami.',
      'Studenci kierunków biznesowych i językowych.',
      'Każdy, kto chce poczuć się pewniej, używając angielskiego w pracy.'
    ],
    whatYouGet: [
      'Znajomość kluczowego słownictwa i zwrotów biznesowych.',
      'Umiejętność pisania profesjonalnych e-maili po angielsku.',
      'Większą swobodę w prowadzeniu rozmów i uczestniczeniu w spotkaniach.',
      'Praktyczne wskazówki dotyczące tworzenia i wygłaszania prezentacji.',
      'Większą pewność siebie w komunikacji biznesowej po angielsku.',
      'Świadomość typowych błędów i jak ich unikać.'
    ],
    faq: [
      { q: 'Jaki poziom angielskiego jest wymagany?', a: 'Kurs jest przeznaczony dla osób znających angielski na poziomie co najmniej średniozaawansowanym (B1/B2), które chcą wyspecjalizować się w komunikacji biznesowej.' },
      { q: 'Czy kurs obejmuje naukę gramatyki?', a: 'Kurs skupia się na praktycznych zwrotach i słownictwie, zakładając opanowanie podstaw gramatyki. Omawiamy jednak typowe błędy gramatyczne w kontekście biznesowym.' }
    ]
  },
  {
    id: 'ai-dla-kazdego',
    title: 'AI dla Każdego: Zrozum i Wykorzystaj Sztuczną Inteligencję w Codziennym Życiu',
    category: 'AI',
    tags: ['ai', 'sztuczna inteligencja', 'chatgpt', 'gemini', 'copilot', 'narzędzia ai', 'automatyzacja', 'produktywność', 'codzienne zastosowania ai', 'bez technicznego żargonu', 'ai dla początkujących'],
    imageUrl: 'https://images.unsplash.com/photo-1516116216624-53e697fedbea?auto=format&fit=crop&q=80&w=400', // OK
    price: 149.99,
    currency: 'PLN',
    rating: 4.9,
    reviews: 920,
    level: 'początkujący',
    duration: 'ok. 2-3 godziny materiału',
    certificate: true,
    bestSeller: true,
    description: 'Sztuczna inteligencja jest wszędzie, ale czy wiesz, jak ją wykorzystać? Ten kurs w przystępny sposób wyjaśni Ci, czym jest AI i pokaże, jak popularne narzędzia (ChatGPT, Gemini, Copilot) mogą ułatwić Ci życie codzienne: pisać e-maile, tworzyć podsumowania, planować podróże, pomagać w nauce i wiele więcej. Bez technicznego żargonu!',
    instructor: 'Popularyzator Nauki i Technologii AI',
    affiliateUrl: '#',
    plan: [
      'Czym jest AI? Podstawowe pojęcia bez żargonu.',
      'Jak działają modele językowe (ChatGPT, Gemini)?',
      'AI jako osobisty asystent (pisanie e-maili, listów).',
      'AI w nauce i samorozwoju (podsumowania, tłumaczenia).',
      'AI w planowaniu codziennych zadań (podróże, przepisy).',
      'Kreatywne zastosowania AI (generowanie grafik, tekstów).',
      'Bezpieczeństwo i etyka w korzystaniu z AI.',
      'Przyszłość AI i jej wpływ na życie.'
    ],
    forWho: [
      'Osoby ciekawe świata AI, które nie mają wiedzy technicznej.',
      'Uczniowie, studenci, pracownicy biurowi.',
      'Seniorzy chcący zrozumieć nowe technologie.',
      'Każdy, kto chce ułatwić sobie codzienne zadania za pomocą dostępnych narzędzi AI.'
    ],
    whatYouGet: [
      'Przystępne zrozumienie czym jest sztuczna inteligencja.',
      'Umiejętność korzystania z podstawowych narzędzi AI (ChatGPT, Gemini, Copilot).',
      'Praktyczne przykłady zastosowania AI w codziennym życiu (pisanie, nauka, planowanie).',
      'Większą pewność siebie w interakcji z nowymi technologiami.',
      'Świadomość możliwości i ograniczeń AI.'
    ],
    faq: [
      { q: 'Czy muszę znać się na komputerach?', a: 'Wystarczy podstawowa umiejętność obsługi komputera i przeglądarki internetowej.' },
      { q: 'Czy potrzebuję płatnych narzędzi AI?', a: 'Kurs skupia się na darmowych lub powszechnie dostępnych wersjach popularnych narzędzi AI.' }
    ]
  }
];